import {
  COLUMN_NAME_PLATFORM,
  COLUMN_NAME_SPEND,
  COLUMN_NAME_IMPRESSIONS,
  COLUMN_NAME_CLICKS,
  COLUMN_NAME_CTR,
  COLUMN_NAME_RESULTS,
  COLUMN_NAME_CPA,
  ALL_CONVERSIONS,
  ALL_CONVERSIONS_FROM_INTERACTIONS_RATE,
  ALL_CONVERSIONS_VALUE,
  APP_EVENT_ADD_TO_CART,
  APP_INSTALL,
  AVERAGE_CART_SIZE,
  AVERAGE_COST,
  AVERAGE_CPC,
  AVERAGE_ORDER_VALUE_MICROS,
  CHECKOUT,
  COMMENTS_METRICS,
  CONVERSION_RATE,
  CONVERSIONS_FROM_INTERACTIONS_RATE,
  CONVERSIONS_VALUE,
  COST_OF_GOODS_SOLD_MICROS,
  COST_PER_ALL_CONVERSIONS,
  COST_PER_APP_EVENT_ADD_TO_CART,
  COST_PER_APP_INSTALL,
  COST_PER_CHECKOUT,
  COST_PER_CONVERSION,
  COST_PER_PURCHASE,
  COST_PER_VIEW_CONTENT,
  CROSS_DEVICE_CONVERSIONS,
  CROSS_DEVICE_CONVERSIONS_VALUE_MICROS,
  CROSS_SELL_COST_OF_GOODS_SOLD_MICROS,
  CROSS_SELL_GROSS_PROFIT_MICROS,
  CROSS_SELL_REVENUE_MICROS,
  CROSS_SELL_UNITS_SOLD,
  ENGAGEMENT_RATE,
  FOLLOWS,
  GROSS_PROFIT_MARGIN,
  GROSS_PROFIT_MICROS,
  INTERACTION_RATE,
  INTERACTIONS_METRICS,
  LEAD_COST_OF_GOODS_SOLD_MICROS,
  LEAD_GROSS_PROFIT_MICROS,
  LEAD_REVENUE_MICROS,
  LEAD_UNITS_SOLD,
  LIKES_METRICS,
  ORDERS_METRICS,
  PROFILE_VISITS,
  PURCHASE,
  REVENUE_MICROS,
  SHARES_METRICS,
  VALUE_PER_ALL_CONVERSIONS,
  VALUE_PER_CONVERSION,
  VIDEO_VIEWS_P100,
  VIEW_CONTENT,
  VIEW_THROUGH_CONVERSIONS,
  CPC_METRICS,
  CPM_METRICS,
  ACTION_VALUES,
  ACTIONS_METRICS,
  AD_CLICK_ACTIONS,
  AD_IMPRESSION_ACTIONS,
  AUCTION_BID,
  AUCTION_COMPETITIVENESS,
  AUCTION_MAX_COMPETITOR_BID,
  CANVAS_AVG_VIEW_PERCENT,
  CANVAS_AVG_VIEW_TIME,
  CATALOG_SEGMENT_ACTIONS,
  CATALOG_SEGMENT_VALUE,
  CATALOG_SEGMENT_VALUE_MOBILE_PURCHASE_ROAS,
  CATALOG_SEGMENT_VALUE_OMNI_PURCHASE_ROAS,
  CATALOG_SEGMENT_VALUE_WEBSITE_PURCHASE_ROAS,
  CONVERSION_VALUES,
  CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE,
  CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE,
  CONVERTED_PRODUCT_OFFLINE_PURCHASE,
  CONVERTED_PRODUCT_OFFLINE_PURCHASE_VALUE,
  CONVERTED_PRODUCT_OMNI_PURCHASE,
  CONVERTED_PRODUCT_OMNI_PURCHASE_VALUES,
  CONVERTED_PRODUCT_QUANTITY,
  CONVERTED_PRODUCT_VALUE,
  CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE,
  CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE,
  CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE,
  CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE_VALUE,
  CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE_VALUES,
  CONVERTED_PROMOTED_PRODUCT_QUANTITY,
  CONVERTED_PROMOTED_PRODUCT_VALUE,
  CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE,
  CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE,
  COST_PER_15SEC_VIDEO_VIEW,
  COST_PER_15_SEC_VIDEO_VIEW,
  COST_PER_2SEC_CONTINUOUS_VIDEO_VIEW,
  COST_PER_ACTION_TYPE,
  COST_PER_AD_CLICK,
  COST_PER_DDA_COUNT_BY_CONVS,
  COST_PER_ESTIMATED_AD_RECALLERS,
  COST_PER_INLINE_LINK_CLICK,
  COST_PER_INLINE_POST_ENGAGEMENT,
  COST_PER_OBJECTIVE_RESULT,
  COST_PER_ONE_THOUSAND_AD_IMPRESSION,
  COST_PER_OUTBOUND_CLICK,
  COST_PER_RESULT,
  COST_PER_THRUPLAY,
  COST_PER_UNIQUE_ACTION_TYPE,
  COST_PER_UNIQUE_CLICK,
  COST_PER_UNIQUE_CONVERSION,
  COST_PER_UNIQUE_INLINE_LINK_CLICK,
  COST_PER_UNIQUE_OUTBOUND_CLICK,
  CPP,
  DDA_COUNT_BY_CONVS,
  DDA_RESULTS,
  ESTIMATED_AD_RECALLERS,
  FULL_VIEW_IMPRESSIONS,
  FULL_VIEW_REACH,
  INLINE_LINK_CLICK_CTR,
  INLINE_LINK_CLICKS,
  INLINE_POST_ENGAGEMENT,
  INSTANT_EXPERIENCE_CLICKS_TO_OPEN,
  INSTANT_EXPERIENCE_CLICKS_TO_START,
  INSTANT_EXPERIENCE_OUTBOUND_CLICKS,
  INTERACTIVE_COMPONENT_TAP,
  LANDING_PAGE_VIEW_PER_LINK_CLICK,
  MARKETING_MESSAGES_DELIVERY_RATE,
  OBJECTIVE_RESULT_RATE,
  OBJECTIVE_RESULTS,
  OUTBOUND_CLICKS,
  OUTBOUND_CLICKS_CTR,
  PURCHASE_PER_LANDING_PAGE_VIEW,
  QUALIFYING_QUESTION_QUALIFY_ANSWER_RATE,
  RESULT_RATE,
  RESULTS_METRICS,
  ROAS_METRICS,
  SHOPS_ASSISTED_PURCHASES,
  SOCIAL_SPEND,
  TOTAL_CARD_VIEW,
  VIDEO_30SEC_WATCHED_ACTIONS,
  VIDEO_30_SEC_WATCHED_ACTIONS,
  VIDEO_AVG_TIME_WATCHED_ACTIONS,
  VIDEO_CONTINUOUS_2SEC_WATCHED_ACTIONS,
  VIDEO_P100_WATCHED_ACTIONS,
  VIDEO_P25_WATCHED_ACTIONS,
  VIDEO_P50_WATCHED_ACTIONS,
  VIDEO_P75_WATCHED_ACTIONS,
  VIDEO_P95_WATCHED_ACTIONS,
  VIDEO_PLAY_ACTIONS,
  VIDEO_PLAY_CURVE_ACTIONS,
  VIDEO_PLAY_RETENTION_0_TO_15S_ACTIONS,
  VIDEO_PLAY_RETENTION_20_TO_60S_ACTIONS,
  VIDEO_PLAY_RETENTION_GRAPH_ACTIONS,
  VIDEO_TIME_WATCHED_ACTIONS,
  WEBSITE_CTR,
  WEBSITE_PURCHASE_ROAS,
  FREQUENCY,
  BILLED_COST,
  GROSS_IMPRESSIONS,
  AVERAGE_VIDEO_PLAY,
  LIVE_VIEWS,
  REGISTRATION,
  COST_PER_REGISTRATION,
  PURCHASE_RATE,
  TOTAL_PURCHASE_VALUE,
  NEXT_DAY_OPEN,
  DAY7_RETENTION,
  CASH_SPEND,
  VOUCHER_SPEND,
  COST_PER_1000_REACHED,
  CONVERSION_RATE_V2,
  REAL_TIME_CONVERSION,
  REAL_TIME_COST_PER_CONVERSION,
  REAL_TIME_CONVERSION_RATE,
  REAL_TIME_CONVERSION_RATE_V2,
  REAL_TIME_RESULT,
  REAL_TIME_COST_PER_RESULT,
  REAL_TIME_RESULT_RATE,
  SECONDARY_GOAL_RESULT,
  COST_PER_SECONDARY_GOAL_RESULT,
  SECONDARY_GOAL_RESULT_RATE,
  VIDEO_WATCHED_2S,
  VIDEO_WATCHED_6S,
  VIDEO_VIEWS_P25,
  VIDEO_VIEWS_P50,
  VIDEO_VIEWS_P75,
  AVERAGE_VIDEO_PLAY_PER_USER,
  PAID_ENGAGED_VIEW,
  PAID_ENGAGEMENT_ENGAGED_VIEW,
  ENGAGED_VIEW_15S,
  PAID_ENGAGED_VIEW_15S,
  PAID_ENGAGEMENT_ENGAGED_VIEW_15S,
  CLICKS_ON_MUSIC_DISC,
  DUET_CLICKS,
  STITCH_CLICKS,
  SOUND_USAGE_CLICKS,
  ANCHOR_CLICKS,
  ANCHOR_CLICK_RATE,
  CLICKS_ON_HASHTAG_CHALLENGE,
  PROFILE_VISITS_RATE,
  TT_PLAYLIST_VISIT,
  TT_PLAYLIST_VISIT_RATE,
  LIVE_UNIQUE_VIEWS,
  LIVE_EFFECTIVE_VIEWS,
  LIVE_PRODUCT_CLICKS,
  INTERACTIVE_ADD_ON_IMPRESSIONS,
  INTERACTIVE_ADD_ON_DESTINATION_CLICKS,
  INTERACTIVE_ADD_ON_ACTIVITY_CLICKS,
  INTERACTIVE_ADD_ON_OPTION_A_CLICKS,
  INTERACTIVE_ADD_ON_OPTION_B_CLICKS,
  COUNTDOWN_STICKER_RECALL_CLICKS,
  IX_PAGE_DURATION_AVG,
  IX_PAGE_VIEWRATE_AVG,
  IX_VIDEO_VIEWS,
  IX_VIDEO_VIEWS_P25,
  IX_VIDEO_VIEWS_P50,
  IX_VIDEO_VIEWS_P75,
  IX_VIDEO_VIEWS_P100,
  IX_AVERAGE_VIDEO_PLAY,
  REAL_TIME_APP_INSTALL,
  REAL_TIME_APP_INSTALL_COST,
  REGISTRATION_RATE,
  TOTAL_REGISTRATION,
  COST_PER_TOTAL_REGISTRATION,
  TOTAL_PURCHASE,
  COST_PER_TOTAL_PURCHASE,
  VALUE_PER_TOTAL_PURCHASE,
  TOTAL_ACTIVE_PAY_ROAS,
  TOTAL_PURCHASE_ROAS_DAY0,
  TOTAL_PURCHASE_ROAS_DAY2,
  TOTAL_PURCHASE_ROAS_DAY6,
  TOTAL_PURCHASE_VALUE_DAY0,
  TOTAL_PURCHASE_VALUE_DAY2,
  TOTAL_PURCHASE_VALUE_DAY6,
  APP_EVENT_ADD_TO_CART_RATE,
  TOTAL_APP_EVENT_ADD_TO_CART,
  COST_PER_TOTAL_APP_EVENT_ADD_TO_CART,
  VALUE_PER_TOTAL_APP_EVENT_ADD_TO_CART,
  TOTAL_APP_EVENT_ADD_TO_CART_VALUE,
  CHECKOUT_RATE,
  TOTAL_CHECKOUT,
  COST_PER_TOTAL_CHECKOUT,
  VALUE_PER_CHECKOUT,
  TOTAL_CHECKOUT_VALUE,
  VIEW_CONTENT_RATE,
  TOTAL_VIEW_CONTENT,
  COST_PER_TOTAL_VIEW_CONTENT,
  VALUE_PER_TOTAL_VIEW_CONTENT,
  TOTAL_VIEW_CONTENT_VALUE,
  COST_PER_NEXT_DAY_OPEN,
  NEXT_DAY_OPEN_RATE,
  TOTAL_NEXT_DAY_OPEN,
  COST_PER_TOTAL_NEXT_DAY_OPEN,
  COST_PER_DAY7_RETENTION,
  DAY7_RETENTION_RATE,
  TOTAL_DAY7_RETENTION,
  COST_PER_TOTAL_DAY7_RETENTION,
  VALUE_PER_TOTAL_DAY7_RETENTION,
  TOTAL_DAY7_RETENTION_VALUE,
  ADD_PAYMENT_INFO,
  COST_PER_ADD_PAYMENT_INFO,
  ADD_PAYMENT_INFO_RATE,
  TOTAL_ADD_PAYMENT_INFO,
  COST_TOTAL_ADD_PAYMENT_INFO,
  ADD_TO_WISHLIST,
  COST_PER_ADD_TO_WISHLIST,
  ADD_TO_WISHLIST_RATE,
  TOTAL_ADD_TO_WISHLIST,
  COST_PER_TOTAL_ADD_TO_WISHLIST,
  VALUE_PER_TOTAL_ADD_TO_WISHLIST,
  TOTAL_ADD_TO_WISHLIST_VALUE,
  LAUNCH_APP,
  COST_PER_LAUNCH_APP,
  LAUNCH_APP_RATE,
  TOTAL_LAUNCH_APP,
  COST_PER_TOTAL_LAUNCH_APP,
  COMPLETE_TUTORIAL,
  COST_PER_COMPLETE_TUTORIAL,
  COMPLETE_TUTORIAL_RATE,
  TOTAL_COMPLETE_TUTORIAL,
  COST_PER_TOTAL_COMPLETE_TUTORIAL,
  VALUE_PER_TOTAL_COMPLETE_TUTORIAL,
  TOTAL_COMPLETE_TUTORIAL_VALUE,
  CREATE_GROUP,
  COST_PER_CREATE_GROUP,
  CREATE_GROUP_RATE,
  TOTAL_CREATE_GROUP,
  COST_PER_TOTAL_CREATE_GROUP,
  VALUE_PER_TOTAL_CREATE_GROUP,
  TOTAL_CREATE_GROUP_VALUE,
  JOIN_GROUP,
  COST_PER_JOIN_GROUP,
  JOIN_GROUP_RATE,
  TOTAL_JOIN_GROUP,
  COST_PER_TOTAL_JOIN_GROUP,
  VALUE_PER_TOTAL_JOIN_GROUP,
  TOTAL_JOIN_GROUP_VALUE,
  CREATE_GAMEROLE,
  COST_PER_CREATE_GAMEROLE,
  CREATE_GAMEROLE_RATE,
  TOTAL_CREATE_GAMEROLE,
  COST_PER_TOTAL_CREATE_GAMEROLE,
  VALUE_PER_TOTAL_CREATE_GAMEROLE,
  TOTAL_CREATE_GAMEROLE_VALUE,
  SPEND_CREDITS,
  COST_PER_SPEND_CREDITS,
  SPEND_CREDITS_RATE,
  TOTAL_SPEND_CREDITS,
  COST_PER_TOTAL_SPEND_CREDITS,
  VALUE_PER_TOTAL_SPEND_CREDITS,
  TOTAL_SPEND_CREDITS_VALUE,
  ACHIEVE_LEVEL,
  COST_PER_ACHIEVE_LEVEL,
  ACHIEVE_LEVEL_RATE,
  TOTAL_ACHIEVE_LEVEL,
  COST_PER_TOTAL_ACHIEVE_LEVEL,
  VALUE_PER_TOTAL_ACHIEVE_LEVEL,
  TOTAL_ACHIEVE_LEVEL_VALUE,
  UNLOCK_ACHIEVEMENT,
  COST_PER_UNLOCK_ACHIEVEMENT,
  UNLOCK_ACHIEVEMENT_RATE,
  TOTAL_UNLOCK_ACHIEVEMENT,
  COST_PER_TOTAL_UNLOCK_ACHIEVEMENT,
  VALUE_PER_TOTAL_UNLOCK_ACHIEVEMENT,
  TOTAL_UNLOCK_ACHIEVEMENT_VALUE,
  SALES_LEAD,
  COST_PER_SALES_LEAD,
  SALES_LEAD_RATE,
  TOTAL_SALES_LEAD,
  COST_PER_TOTAL_SALES_LEAD,
  VALUE_PER_TOTAL_SALES_LEAD,
  TOTAL_SALES_LEAD_VALUE,
  IN_APP_AD_CLICK,
  COST_PER_IN_APP_AD_CLICK,
  IN_APP_AD_CLICK_RATE,
  TOTAL_IN_APP_AD_CLICK,
  COST_PER_TOTAL_IN_APP_AD_CLICK,
  VALUE_PER_TOTAL_IN_APP_AD_CLICK,
  TOTAL_IN_APP_AD_CLICK_VALUE,
  IN_APP_AD_IMPR,
  COST_PER_IN_APP_AD_IMPR,
  IN_APP_AD_IMPR_RATE,
  TOTAL_IN_APP_AD_IMPR,
  COST_PER_TOTAL_IN_APP_AD_IMPR,
  VALUE_PER_TOTAL_IN_APP_AD_IMPR,
  TOTAL_IN_APP_AD_IMPR_VALUE,
  LOAN_APPLY,
  COST_PER_LOAN_APPLY,
  LOAN_APPLY_RATE,
  TOTAL_LOAN_APPLY,
  COST_PER_TOTAL_LOAN_APPLY,
  LOAN_CREDIT,
  COST_PER_LOAN_CREDIT,
  LOAN_CREDIT_RATE,
  TOTAL_LOAN_CREDIT,
  COST_PER_TOTAL_LOAN_CREDIT,
  LOAN_DISBURSEMENT,
  COST_PER_LOAN_DISBURSEMENT,
  LOAN_DISBURSEMENT_RATE,
  TOTAL_LOAN_DISBURSEMENT,
  COST_PER_TOTAL_LOAN_DISBURSEMENT,
  LOGIN,
  COST_PER_LOGIN,
  LOGIN_RATE,
  TOTAL_LOGIN,
  COST_PER_TOTAL_LOGIN,
  RATINGS,
  COST_PER_RATINGS,
  RATINGS_RATE,
  TOTAL_RATINGS,
  COST_PER_TOTAL_RATINGS,
  VALUE_PER_TOTAL_RATINGS,
  TOTAL_RATINGS_VALUE,
  SEARCH_TIKTOK,
  COST_PER_SEARCH,
  SEARCH_RATE,
  TOTAL_SEARCH,
  COST_PER_TOTAL_SEARCH,
  START_TRIAL,
  COST_PER_START_TRIAL,
  START_TRIAL_RATE,
  TOTAL_START_TRIAL,
  COST_PER_TOTAL_START_TRIAL,
  SUBSCRIBE,
  COST_PER_SUBSCRIBE,
  SUBSCRIBE_RATE,
  TOTAL_SUBSCRIBE,
  COST_PER_TOTAL_SUBSCRIBE,
  VALUE_PER_TOTAL_SUBSCRIBE,
  TOTAL_SUBSCRIBE_VALUE,
  UNIQUE_CUSTOM_APP_EVENTS,
  COST_PER_UNIQUE_CUSTOM_APP_EVENT,
  CUSTOM_APP_EVENT_RATE,
  CUSTOM_APP_EVENTS,
  COST_PER_CUSTOM_APP_EVENT,
  VALUE_PER_CUSTOM_APP_EVENT,
  CUSTOM_APP_EVENTS_VALUE,
  UNIQUE_AD_IMPRESSION_EVENTS,
  COST_PER_UNIQUE_AD_IMPRESSION_EVENT,
  CUSTOMIZED_AD_IMPRESSION_EVENT_RATE,
  ADS_IMPRESSION_EVENTS,
  COST_PRE_AD_IMPRESSION_EVENT,
  VALUE_PER_AD_IMPRESSION_EVENT,
  TOTAL_AD_IMPRESSION_EVENTS_VALUE,
  TOTAL_AD_IMPRESSION_ROAS,
  AD_IMPRESSION_AD_REVENUE_ROAS_DAY0,
  AD_IMPRESSION_AD_REVENUE_ROAS_DAY2,
  AD_IMPRESSION_AD_REVENUE_ROAS_DAY6,
  AD_IMPRESSION_AD_REVENUE_DAY0,
  AD_IMPRESSION_AD_REVENUE_DAY2,
  AD_IMPRESSION_AD_REVENUE_DAY6,
  COMPLETE_PAYMENT_ROAS,
  COMPLETE_PAYMENT,
  COST_PER_COMPLETE_PAYMENT,
  COMPLETE_PAYMENT_RATE,
  VALUE_PER_COMPLETE_PAYMENT,
  TOTAL_COMPLETE_PAYMENT_RATE,
  TOTAL_LANDING_PAGE_VIEW,
  COST_PER_LANDING_PAGE_VIEW,
  LANDING_PAGE_VIEW_RATE,
  TOTAL_PAGEVIEW,
  COST_PER_PAGEVIEW,
  PAGEVIEW_RATE,
  AVG_VALUE_PER_PAGEVIEW,
  TOTAL_VALUE_PER_PAGEVIEW,
  PAGE_BROWSE_VIEW,
  COST_PER_PAGE_BROWSE_VIEW,
  PAGE_BROWSE_VIEW_RATE,
  TOTAL_PAGE_BROWSE_VIEW_VALUE,
  VALUE_PER_PAGE_BROWSE_VIEW,
  BUTTON_CLICK,
  COST_PER_BUTTON_CLICK,
  BUTTON_CLICK_RATE,
  VALUE_PER_BUTTON_CLICK,
  TOTAL_BUTTON_CLICK_VALUE,
  ONLINE_CONSULT,
  COST_PER_ONLINE_CONSULT,
  ONLINE_CONSULT_RATE,
  VALUE_PER_ONLINE_CONSULT,
  TOTAL_ONLINE_CONSULT_VALUE,
  USER_REGISTRATION,
  COST_PER_USER_REGISTRATION,
  USER_REGISTRATION_RATE,
  VALUE_PER_USER_REGISTRATION,
  TOTAL_USER_REGISTRATION_VALUE,
  PAGE_CONTENT_VIEW_EVENTS,
  COST_PER_PAGE_CONTENT_VIEW_EVENT,
  PAGE_CONTENT_VIEW_EVENT_RATE,
  VALUE_PER_PAGE_CONTENT_VIEW_EVENT,
  TOTAL_PAGE_VIEW_CONTENT_EVENTS_VALUE,
  PRODUCT_DETAILS_PAGE_BROWSE,
  COST_PER_PRODUCT_DETAILS_PAGE_BROWSE,
  PRODUCT_DETAILS_PAGE_BROWSE_RATE,
  VALUE_PER_PRODUCT_DETAILS_PAGE_BROWSE,
  TOTAL_PRODUCT_DETAILS_PAGE_BROWSE_VALUE,
  WEB_EVENT_ADD_TO_CART,
  COST_PER_WEB_EVENT_ADD_TO_CART,
  WEB_EVENT_ADD_TO_CART_RATE,
  VALUE_PER_WEB_EVENT_ADD_TO_CART,
  TOTAL_WEB_EVENT_ADD_TO_CART_VALUE,
  ON_WEB_ORDER,
  COST_PER_ON_WEB_ORDER,
  ON_WEB_ORDER_RATE,
  VALUE_PER_ON_WEB_ORDER,
  TOTAL_ON_WEB_ORDER_VALUE,
  INITIATE_CHECKOUT,
  COST_PER_INITIATE_CHECKOUT,
  INITIATE_CHECKOUT_RATE,
  VALUE_PER_INITIATE_CHECKOUT,
  TOTAL_INITIATE_CHECKOUT_VALUE,
  ADD_BILLING,
  COST_PER_ADD_BILLING,
  ADD_BILLING_RATE,
  VALUE_PER_ADD_BILLING,
  TOTAL_ADD_BILLING_VALUE,
  PAGE_EVENT_SEARCH,
  COST_PER_PAGE_EVENT_SEARCH,
  PAGE_EVENT_SEARCH_RATE,
  VALUE_PER_PAGE_EVENT_SEARCH,
  TOTAL_PAGE_EVENT_SEARCH_VALUE,
  FORM_TIKTOK,
  COST_PER_FORM,
  FORM_RATE,
  VALUE_PER_FORM,
  TOTAL_FORM_VALUE,
  DOWNLOAD_START,
  COST_PER_DOWNLOAD_START,
  DOWNLOAD_START_RATE,
  VALUE_PER_DOWNLOAD_START,
  TOTAL_DOWNLOAD_START_VALUE,
  ON_WEB_ADD_TO_WISHLIST,
  COST_PER_ON_WEB_ADD_TO_WISHLIST,
  ON_WEB_ADD_TO_WISHLIST_PER_CLICK,
  VALUE_PER_ON_WEB_ADD_TO_WISHLIST,
  TOTAL_ON_WEB_ADD_TO_WISHLIST_VALUE,
  ON_WEB_SUBSCRIBE,
  COST_PER_ON_WEB_SUBSCRIBE,
  ON_WEB_SUBSCRIBE_PER_CLICK,
  VALUE_PER_ON_WEB_SUBSCRIBE,
  TOTAL_ON_WEB_SUBSCRIBE_VALUE,
  WEBSITE_TOTAL_FIND_LOCATION,
  WEBSITE_COST_PER_FIND_LOCATION,
  WEBSITE_FIND_LOCATION_RATE,
  WEBSITE_VALUE_PER_FIND_LOCATION,
  WEBSITE_TOTAL_FIND_LOCATION_VALUE,
  WEBSITE_TOTAL_SCHEDULE,
  WEBSITE_COST_PER_SCHEDULE,
  WEBSITE_SCHEDULE_RATE,
  WEBSITE_VALUE_PER_SCHEDULE,
  WEBSITE_TOTAL_SCHEDULE_VALUE,
  WEBSITE_TOTAL_CUSTOMIZE_PRODUCT,
  WEBSITE_COST_PER_CUSTOMIZE_PRODUCT,
  WEBSITE_CUSTOMIZE_PRODUCT_RATE,
  WEBSITE_VALUE_PER_CUSTOMIZE_PRODUCT,
  WEBSITE_TOTAL_CUSTOMIZE_PRODUCT_VALUE,
  CUSTOM_PAGE_EVENTS,
  COST_PER_CUSTOM_PAGE_EVENT,
  CUSTOM_PAGE_EVENT_RATE,
  VALUE_PER_CUSTOM_PAGE_EVENT,
  CUSTOM_PAGE_EVENTS_VALUE,
  ONSITE_PURCHASES_ROAS,
  ONSITE_TOTAL_PURCHASE,
  ONSITE_COST_PER_PURCHASE,
  ONSITE_PURCHASE_RATE,
  ONSITE_VALUE_PER_PURCHASE,
  ONSITE_TOTAL_PURCHASE_VALUE,
  ONSITE_TOTAL_CHECKOUT_INITIATION,
  ONSITE_COST_PER_CHECKOUT_INITIATION,
  ONSITE_CHECKOUT_INITIATION_RATE,
  ONSITE_VALUE_PER_CHECKOUT_INITIATION,
  ONSITE_TOTAL_CHECKOUT_INITIATION_VALUE,
  ONSITE_TOTAL_ADD_TO_CART,
  ONSITE_COST_PER_ADD_TO_CART,
  ONSITE_ADD_TO_CART_RATE,
  ONSITE_VALUE_PER_ADD_TO_CART,
  ONSITE_TOTAL_ADD_TO_CART_VALUE,
  ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW,
  ONSITE_COST_PER_PRODUCT_DETAILS_PAGE_VIEW,
  ONSITE_PRODUCT_DETAILS_PAGE_VIEW_RATE,
  ONSITE_VALUE_PER_PRODUCT_DETAILS_PAGE_VIEW,
  ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW_VALUE,
  ONSITE_ADD_TO_WISHLIST,
  COST_PER_ONSITE_ADD_TO_WISHLIST,
  ONSITE_ADD_TO_WISHLIST_RATE,
  VALUE_PER_ONSITE_ADD_TO_WISHLIST,
  TOTAL_ONSITE_ADD_TO_WISHLIST_VALUE,
  ONSITE_ADD_BILLING,
  COST_PER_ONSITE_ADD_BILLING,
  ONSITE_ADD_BILLING_RATE,
  VALUE_PER_ONSITE_ADD_BILLING,
  TOTAL_ONSITE_ADD_BILLING_VALUE,
  ONSITE_FORM,
  COST_PER_ONSITE_FORM,
  ONSITE_FORM_RATE,
  VALUE_PER_ONSITE_FORM,
  TOTAL_ONSITE_FORM_VALUE,
  ONSITE_TOTAL_FILTERED_OUT_FORM_SUBMISSION,
  ONSITE_DOWNLOAD_START,
  COST_PER_ONSITE_DOWNLOAD_START,
  ONSITE_DOWNLOAD_START_RATE,
  ONSITE_DESTINATION_VISITS,
  COST_PER_ONSITE_DESTINATION_VISIT,
  ONSITE_DESTINATION_VISIT_RATE,
  IX_PAGE_VIEW_COUNT,
  COST_PER_IX_PAGE_VIEW_COUNT,
  IX_PAGE_VIEW_COUNT_RATE,
  IX_BUTTON_CLICK_COUNT,
  COST_PER_IX_BUTTON_CLICK_COUNT,
  IX_BUTTON_CLICK_COUNT_RATE,
  IX_PRODUCT_CLICK_COUNT,
  COST_PER_IX_PRODUCT_CLICK_COUNT,
  IX_PRODUCT_CLICK_COUNT_RATE,
  OFFLINE_TOTAL_CRM_EVENTS,
  OFFLINE_COST_PER_CRM_EVENT,
  OFFLINE_CRM_EVENT_RATE,
  OFFLINE_VALUE_PER_CRM_EVENT,
  OFFLINE_CRM_EVENT_VALUE,
  OFFLINE_SHOPPING_EVENTS,
  COST_PER_OFFLINE_SHOPPING_EVENT,
  OFFLINE_SHOPPING_EVENT_RATE,
  VALUE_PER_OFFLINE_SHOPPING_EVENT,
  OFFLINE_SHOPPING_EVENTS_VALUE,
  OFFLINE_SHOPPING_EVENTS_ROAS,
  OFFLINE_CONTACT_EVENTS,
  COST_PER_OFFLINE_CONTACT_EVENT,
  OFFLINE_CONTACT_EVENT_RATE,
  VALUE_PER_OFFLINE_CONTACT_EVENT,
  OFFLINE_CONTACT_EVENTS_VALUE,
  OFFLINE_SUBSCRIBE_EVENTS,
  COST_PER_OFFLINE_SUBSCRIBE_EVENT,
  OFFLINE_SUBSCRIBE_EVENT_RATE,
  VALUE_PER_OFFLINE_SUBSCRIBE_EVENT,
  OFFLINE_SUBSCRIBE_EVENTS_VALUE,
  OFFLINE_FORM_EVENTS,
  COST_PER_OFFLINE_FORM_EVENT,
  OFFLINE_FORM_EVENT_RATE,
  VALUE_PER_OFFLINE_FORM_EVENT,
  OFFLINE_FORM_EVENTS_VALUE,
  OFFLINE_ADD_PAYMENT_INFO_EVENTS,
  COST_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT,
  OFFLINE_ADD_PAYMENT_INFO_EVENT_RATE,
  VALUE_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT,
  OFFLINE_ADD_PAYMENT_INFO_EVENTS_VALUE,
  OFFLINE_ADD_TO_CART_EVENTS,
  COST_PER_OFFLINE_ADD_TO_CART_EVENT,
  OFFLINE_ADD_TO_CART_EVENT_RATE,
  VALUE_PER_OFFLINE_ADD_TO_CART_EVENT,
  OFFLINE_ADD_TO_CART_EVENTS_VALUE,
  OFFLINE_ADD_TO_WISHLIST_EVENTS,
  COST_PER_OFFLINE_ADD_TO_WISHLIST_EVENT,
  OFFLINE_ADD_TO_WISHLIST_EVENT_RATE,
  VALUE_PER_OFFLINE_ADD_TO_WISHLIST_EVENT,
  OFFLINE_ADD_TO_WISHLIST_EVENTS_VALUE,
  OFFLINE_CLICK_BUTTON_EVENTS,
  COST_PER_OFFLINE_CLICK_BUTTON_EVENT,
  OFFLINE_CLICK_BUTTON_EVENT_RATE,
  VALUE_PER_OFFLINE_CLICK_BUTTON_EVENT,
  OFFLINE_CLICK_BUTTON_EVENTS_VALUE,
  OFFLINE_COMPLETE_REGISTRATION_EVENTS,
  COST_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT,
  OFFLINE_COMPLETE_REGISTRATION_EVENT_RATE,
  VALUE_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT,
  OFFLINE_COMPLETE_REGISTRATION_EVENTS_VALUE,
  OFFLINE_DOWNLOAD_EVENTS,
  COST_PER_OFFLINE_DOWNLOAD_EVENT,
  OFFLINE_DOWNLOAD_EVENT_RATE,
  VALUE_PER_OFFLINE_DOWNLOAD_EVENT,
  OFFLINE_DOWNLOAD_EVENTS_VALUE,
  OFFLINE_INITIATE_CHECKOUT_EVENTS,
  COST_PER_OFFLINE_INITIATE_CHECKOUT_EVENT,
  OFFLINE_INITIATE_CHECKOUT_EVENT_RATE,
  VALUE_PER_OFFLINE_INITIATE_CHECKOUT_EVENT,
  OFFLINE_INITIATE_CHECKOUT_EVENTS_VALUE,
  OFFLINE_PLACE_ORDER_EVENTS,
  COST_PER_OFFLINE_PLACE_ORDER_EVENT,
  OFFLINE_PLACE_ORDER_EVENT_RATE,
  VALUE_PER_OFFLINE_PLACE_ORDER_EVENT,
  OFFLINE_PLACE_ORDER_EVENTS_VALUE,
  OFFLINE_SEARCH_EVENTS,
  COST_PER_OFFLINE_SEARCH_EVENT,
  OFFLINE_SEARCH_EVENT_RATE,
  VALUE_PER_OFFLINE_SEARCH_EVENT,
  OFFLINE_SEARCH_EVENTS_VALUE,
  OFFLINE_VIEW_CONTENT_EVENTS,
  COST_PER_OFFLINE_VIEW_CONTENT_EVENT,
  OFFLINE_VIEW_CONTENT_EVENT_RATE,
  VALUE_PER_OFFLINE_VIEW_CONTENT_EVENT,
  OFFLINE_VIEW_CONTENT_EVENTS_VALUE,
  OFFLINE_PREFERRED_LEADS,
  OFFLINE_COST_PER_PREFERRED_LEAD,
  OFFLINE_PREFERRED_LEAD_RATE,
  OFFLINE_TOTAL_FIND_LOCATION,
  OFFLINE_COST_PER_FIND_LOCATION,
  OFFLINE_FIND_LOCATION_RATE,
  OFFLINE_VALUE_PER_FIND_LOCATION,
  OFFLINE_TOTAL_FIND_LOCATION_VALUE,
  OFFLINE_TOTAL_SCHEDULE,
  OFFLINE_COST_PER_SCHEDULE,
  OFFLINE_SCHEDULE_RATE,
  OFFLINE_VALUE_PER_SCHEDULE,
  OFFLINE_TOTAL_SCHEDULE_VALUE,
  OFFLINE_TOTAL_CUSTOMIZE_PRODUCT,
  OFFLINE_COST_PER_CUSTOMIZE_PRODUCT,
  OFFLINE_CUSTOMIZE_PRODUCT_RATE,
  OFFLINE_VALUE_PER_CUSTOMIZE_PRODUCT,
  OFFLINE_TOTAL_CUSTOMIZE_PRODUCT_VALUE,
  OFFLINE_TOTAL_CUSTOM_EVENTS,
  OFFLINE_COST_PER_CUSTOM_EVENT,
  OFFLINE_CUSTOM_EVENT_RATE,
  OFFLINE_VALUE_PER_CUSTOM_EVENT,
  OFFLINE_TOTAL_CUSTOM_EVENT_VALUE,
  MESSAGING_TOTAL_CONVERSATION_TIKTOK_DIRECT_MESSAGE,
  MESSAGING_COST_PER_CONVERSATION_TIKTOK_DIRECT_MESSAGE,
  MESSAGING_CONVERSATION_RATE_TIKTOK_DIRECT_MESSAGE,
  MESSAGING_TOTAL_CONVERSATION_INSTANT_MESSAGING_APP,
  MESSAGING_COST_PER_CONVERSATION_INSTANT_MESSAGING_APP,
  MESSAGING_CONVERSATION_RATE_INSTANT_MESSAGING_APP,
  ONSITE_SHOPPING_ROAS,
  ONSITE_SHOPPING,
  COST_PER_ONSITE_SHOPPING,
  ONSITE_SHOPPING_RATE,
  VALUE_PER_ONSITE_SHOPPING,
  TOTAL_ONSITE_SHOPPING_VALUE,
  SHOP_TOTAL_PURCHASE_BY_ORDER_SUBMISSION,
  SHOP_GROSS_REVENUE_BY_ORDER_SUBMISSION,
  SHOP_TOTAL_ITEMS_PURCHASED,
  ONSITE_INITIATE_CHECKOUT_COUNT,
  COST_PER_ONSITE_INITIATE_CHECKOUT_COUNT,
  ONSITE_INITIATE_CHECKOUT_COUNT_RATE,
  VALUE_PER_ONSITE_INITIATE_CHECKOUT_COUNT,
  TOTAL_ONSITE_INITIATE_CHECKOUT_COUNT_VALUE,
  ONSITE_ON_WEB_DETAIL,
  COST_PER_ONSITE_ON_WEB_DETAIL,
  ONSITE_ON_WEB_DETAIL_RATE,
  VALUE_PER_ONSITE_ON_WEB_DETAIL,
  TOTAL_ONSITE_ON_WEB_DETAIL_VALUE,
  ONSITE_ON_WEB_CART,
  COST_PER_ONSITE_ON_WEB_CART,
  ONSITE_ON_WEB_CART_RATE,
  VALUE_PER_ONSITE_ON_WEB_CART,
  TOTAL_ONSITE_ON_WEB_CART_VALUE,
  VTA_CONVERSION,
  COST_PER_VTA_CONVERSION,
  CTA_CONVERSION,
  COST_PER_CTA_CONVERSION,
  ENGAGED_VIEW_THROUGH_CONVERSIONS,
  COST_PER_ENGAGED_VIEW_THROUGH_CONVERSION,
  VTA_APP_INSTALL,
  COST_PER_VTA_APP_INSTALL,
  CTA_APP_INSTALL,
  COST_PER_CTA_APP_INSTALL,
  EVTA_APP_INSTALL,
  COST_PER_EVTA_APP_INSTALL,
  VTA_REGISTRATION,
  COST_PER_VTA_REGISTRATION,
  CTA_REGISTRATION,
  COST_PER_CTA_REGISTRATION,
  EVTA_REGISTRATION,
  COST_PER_EVTA_REGISTRATION,
  VTA_PURCHASE,
  COST_PER_VTA_PURCHASE,
  CTA_PURCHASE,
  COST_PER_CTA_PURCHASE,
  EVTA_PURCHASE,
  COST_PER_EVTA_PURCHASE,
  VTA_COMPLETE_PAYMENT,
  COST_PER_VTA_PAYMENTS_COMPLETED,
  EVTA_PAYMENTS_COMPLETED,
  COST_PER_EVTA_PAYMENTS_COMPLETED,
  VTA_COMPLETE_PAYMENT_VALUE,
  VTA_COMPLETE_PAYMENT_ROAS,
  SKAN_RESULT,
  SKAN_COST_PER_RESULT,
  SKAN_RESULT_RATE,
  SKAN_CONVERSION,
  SKAN_COST_PER_CONVERSION,
  SKAN_CONVERSION_RATE,
  SKAN_CONVERSION_RATE_V2,
  SKAN_CLICK_TIME_CONVERSION,
  SKAN_CLICK_TIME_COST_PER_CONVERSION,
  SKAN_CLICK_TIME_CONVERSION_RATE,
  SKAN_CLICK_TIME_CONVERSION_RATE_V2,
  SKAN_APP_INSTALL,
  SKAN_COST_PER_APP_INSTALL,
  SKAN_APP_INSTALL_WITHHELD,
  SKAN_REGISTRATION,
  SKAN_COST_PER_REGISTRATION,
  SKAN_REGISTRATION_RATE,
  SKAN_TOTAL_REGISTRATION,
  SKAN_COST_PER_TOTAL_REGISTRATION,
  SKAN_PURCHASE,
  SKAN_COST_PER_PURCHASE,
  SKAN_PURCHASE_RATE,
  SKAN_TOTAL_PURCHASE,
  SKAN_COST_PER_TOTAL_PURCHASE,
  SKAN_TOTAL_PURCHASE_VALUE,
  SKAN_TOTAL_REPETITIVE_ACTIVE_PAY_ROAS,
  SKAN_ADD_TO_CART,
  SKAN_COST_PER_ADD_TO_CART,
  SKAN_ADD_TO_CART_RATE,
  SKAN_TOTAL_ADD_TO_CART,
  SKAN_COST_PER_TOTAL_ADD_TO_CART,
  SKAN_TOTAL_ADD_TO_CART_VALUE,
  SKAN_CHECKOUT,
  SKAN_COST_PER_CHECKOUT,
  SKAN_CHECKOUT_RATE,
  SKAN_TOTAL_CHECKOUT,
  SKAN_COST_PER_TOTAL_CHECKOUT,
  SKAN_TOTAL_CHECKOUT_VALUE,
  SKAN_VIEW_CONTENT,
  SKAN_COST_PER_VIEW_CONTENT,
  SKAN_VIEW_CONTENT_RATE,
  SKAN_TOTAL_VIEW_CONTENT,
  SKAN_COST_PER_TOTAL_VIEW_CONTENT,
  SKAN_TOTAL_VIEW_CONTENT_VALUE,
  SKAN_ADD_PAYMENT_INFO,
  SKAN_COST_PER_ADD_PAYMENT_INFO,
  SKAN_ADD_PAYMENT_INFO_RATE,
  SKAN_TOTAL_ADD_PAYMENT_INFO,
  SKAN_COST_TOTAL_ADD_PAYMENT_INFO,
  SKAN_ADD_TO_WISHLIST,
  SKAN_COST_PER_ADD_TO_WISHLIST,
  SKAN_ADD_TO_WISHLIST_RATE,
  SKAN_TOTAL_ADD_TO_WISHLIST,
  SKAN_COST_PER_TOTAL_ADD_TO_WISHLIST,
  SKAN_TOTAL_ADD_TO_WISHLIST_VALUE,
  SKAN_LAUNCH_APP,
  SKAN_COST_PER_LAUNCH_APP,
  SKAN_LAUNCH_APP_RATE,
  SKAN_TOTAL_LAUNCH_APP,
  SKAN_COST_PER_TOTAL_LAUNCH_APP,
  SKAN_COMPLETE_TUTORIAL,
  SKAN_COST_PER_COMPLETE_TUTORIAL,
  SKAN_COMPLETE_TUTORIAL_RATE,
  SKAN_TOTAL_COMPLETE_TUTORIAL,
  SKAN_COST_PER_TOTAL_COMPLETE_TUTORIAL,
  SKAN_TOTAL_COMPLETE_TUTORIAL_VALUE,
  SKAN_CREATE_GROUP,
  SKAN_COST_PER_CREATE_GROUP,
  SKAN_CREATE_GROUP_RATE,
  SKAN_TOTAL_CREATE_GROUP,
  SKAN_COST_PER_TOTAL_CREATE_GROUP,
  SKAN_TOTAL_CREATE_GROUP_VALUE,
  SKAN_JOIN_GROUP,
  SKAN_COST_PER_JOIN_GROUP,
  SKAN_JOIN_GROUP_RATE,
  SKAN_TOTAL_JOIN_GROUP,
  SKAN_COST_PER_TOTAL_JOIN_GROUP,
  SKAN_TOTAL_JOIN_GROUP_VALUE,
  SKAN_CREATE_GAMEROLE,
  SKAN_COST_PER_CREATE_GAMEROLE,
  SKAN_CREATE_GAMEROLE_RATE,
  SKAN_TOTAL_CREATE_GAMEROLE,
  SKAN_COST_PER_TOTAL_CREATE_GAMEROLE,
  SKAN_TOTAL_CREATE_GAMEROLE_VALUE,
  SKAN_SPEND_CREDITS,
  SKAN_COST_PER_SPEND_CREDITS,
  SKAN_SPEND_CREDITS_RATE,
  SKAN_TOTAL_SPEND_CREDITS,
  SKAN_COST_PER_TOTAL_SPEND_CREDITS,
  SKAN_TOTAL_SPEND_CREDITS_VALUE,
  SKAN_ACHIEVE_LEVEL,
  SKAN_COST_PER_ACHIEVE_LEVEL,
  SKAN_ACHIEVE_LEVEL_RATE,
  SKAN_TOTAL_ACHIEVE_LEVEL,
  SKAN_COST_PER_TOTAL_ACHIEVE_LEVEL,
  SKAN_TOTAL_ACHIEVE_LEVEL_VALUE,
  SKAN_UNLOCK_ACHIEVEMENT,
  SKAN_COST_PER_UNLOCK_ACHIEVEMENT,
  SKAN_UNLOCK_ACHIEVEMENT_RATE,
  SKAN_TOTAL_UNLOCK_ACHIEVEMENT,
  SKAN_COST_PER_TOTAL_UNLOCK_ACHIEVEMENT,
  SKAN_TOTAL_UNLOCK_ACHIEVEMENT_VALUE,
  SKAN_SALES_LEAD,
  SKAN_COST_PER_SALES_LEAD,
  SKAN_SALES_LEAD_RATE,
  SKAN_TOTAL_SALES_LEAD,
  SKAN_COST_PER_TOTAL_SALES_LEAD,
  SKAN_TOTAL_SALES_LEAD_VALUE,
  SKAN_IN_APP_AD_CLICK,
  SKAN_COST_PER_IN_APP_AD_CLICK,
  SKAN_IN_APP_AD_CLICK_RATE,
  SKAN_TOTAL_IN_APP_AD_CLICK,
  SKAN_COST_PER_TOTAL_IN_APP_AD_CLICK,
  SKAN_TOTAL_IN_APP_AD_CLICK_VALUE,
  SKAN_IN_APP_AD_IMPR,
  SKAN_COST_PER_IN_APP_AD_IMPR,
  SKAN_IN_APP_AD_IMPR_RATE,
  SKAN_TOTAL_IN_APP_AD_IMPR,
  SKAN_COST_PER_TOTAL_IN_APP_AD_IMPR,
  SKAN_TOTAL_IN_APP_AD_IMPR_VALUE,
  SKAN_LOAN_APPLY,
  SKAN_COST_PER_LOAN_APPLY,
  SKAN_LOAN_APPLY_RATE,
  SKAN_TOTAL_LOAN_APPLY,
  SKAN_COST_PER_TOTAL_LOAN_APPLY,
  SKAN_LOAN_CREDIT,
  SKAN_COST_PER_LOAN_CREDIT,
  SKAN_LOAN_CREDIT_RATE,
  SKAN_TOTAL_LOAN_CREDIT,
  SKAN_COST_PER_TOTAL_LOAN_CREDIT,
  SKAN_LOAN_DISBURSEMENT,
  SKAN_COST_PER_LOAN_DISBURSEMENT,
  SKAN_LOAN_DISBURSEMENT_RATE,
  SKAN_TOTAL_LOAN_DISBURSEMENT,
  SKAN_COST_PER_TOTAL_LOAN_DISBURSEMENT,
  SKAN_LOGIN,
  SKAN_COST_PER_LOGIN,
  SKAN_LOGIN_RATE,
  SKAN_TOTAL_LOGIN,
  SKAN_COST_PER_TOTAL_LOGIN,
  SKAN_RATINGS,
  SKAN_COST_PER_RATINGS,
  SKAN_RATINGS_RATE,
  SKAN_TOTAL_RATINGS,
  SKAN_COST_PER_TOTAL_RATINGS,
  SKAN_TOTAL_RATINGS_VALUE,
  SKAN_SEARCH,
  SKAN_COST_PER_SEARCH,
  SKAN_SEARCH_RATE,
  SKAN_TOTAL_SEARCH,
  SKAN_COST_PER_TOTAL_SEARCH,
  SKAN_START_TRIAL,
  SKAN_COST_PER_START_TRIAL,
  SKAN_START_TRIAL_RATE,
  SKAN_TOTAL_START_TRIAL,
  SKAN_COST_PER_TOTAL_START_TRIAL,
  SKAN_SUBSCRIBE,
  SKAN_COST_PER_SUBSCRIBE,
  SKAN_SUBSCRIBE_RATE,
  SKAN_TOTAL_SUBSCRIBE,
  SKAN_COST_PER_TOTAL_SUBSCRIBE,
  SKAN_TOTAL_SUBSCRIBE_VALUE,
  SKAN_VTA_CONVERSION,
  SKAN_COST_PER_VTA_CONVERSION,
  SKAN_VTA_APP_INSTALL,
  SKAN_COST_PER_VTA_APP_INSTALL,
  SKAN_VTA_REGISTRATION,
  SKAN_COST_PER_VTA_REGISTRATION,
  SKAN_VTA_PURCHASE,
  SKAN_COST_PER_VTA_PURCHASE,
  SKAN_CTA_CONVERSION,
  SKAN_COST_PER_CTA_CONVERSION,
  SKAN_CTA_APP_INSTALL,
  SKAN_COST_PER_CTA_APP_INSTALL,
  SKAN_CTA_REGISTRATION,
  SKAN_COST_PER_CTA_REGISTRATION,
  SKAN_CTA_PURCHASE,
  SKAN_COST_PER_CTA_PURCHASE,
  LIKES,
  COMMENTS,
  SHARES,
  COMMENTS_LINKEDIN,
  COMPANY_PAGE_CLICKS_LINKEDIN,
  EXTERNAL_WEBSITE_CONVERSIONS_LINKEDIN,
  FOLLOWS_LINKEDIN,
  FULL_SCREEN_PLAYS_LINKEDIN,
  LANDING_PAGE_CLICKS_LINKEDIN,
  LIKES_LINKEDIN,
  REACTIONS_LINKEDIN,
  SHARES_LINKEDIN,
  TOTAL_ENGAGEMENTS_LINKEDIN,
  VIDEO_COMPLETIONS_LINKEDIN,
  VIDEO_STARTS_LINKEDIN,
  VIDEO_VIEWS_LINKEDIN,
  VIDEO_HOOK_RATE,
  VIDEO_RETENTION_RATE,
} from "../../../../i18n/keysTranslations";
import { GOOGLE, META, TIKTOK, LINKEDIN } from "../../../../utils/constants";

// Métricas básicas de LinkedIn (siempre visibles)
const LINKEDIN_BASIC_METRICS = [
  { key: "platform", label: COLUMN_NAME_PLATFORM },
  { key: "spend", label: COLUMN_NAME_SPEND, sortable: true },
  { key: "impressions", label: COLUMN_NAME_IMPRESSIONS, sortable: true },
  { key: "click", label: COLUMN_NAME_CLICKS, sortable: true },
  { key: "ctr", label: COLUMN_NAME_CTR, sortable: true },
  { key: "mainAction", label: COLUMN_NAME_RESULTS, sortable: true },
  { key: "costPerMainAction", label: COLUMN_NAME_CPA, sortable: true },
  { key: "cpc", label: CPC_METRICS, sortable: true },
  { key: "cpm", label: CPM_METRICS, sortable: true },
];

// Métricas adicionales de LinkedIn
const LINKEDIN_ADDITIONAL_METRICS = [
  { key: "comments", label: COMMENTS_LINKEDIN, sortable: true },
  {
    key: "companyPageClicks",
    label: COMPANY_PAGE_CLICKS_LINKEDIN,
    sortable: true,
  },
  {
    key: "externalWebsiteConversions",
    label: EXTERNAL_WEBSITE_CONVERSIONS_LINKEDIN,
    sortable: true,
  },
  { key: "follows", label: FOLLOWS_LINKEDIN, sortable: true },
  { key: "fullScreenPlays", label: FULL_SCREEN_PLAYS_LINKEDIN, sortable: true },
  {
    key: "landingPageClicks",
    label: LANDING_PAGE_CLICKS_LINKEDIN,
    sortable: true,
  },
  { key: "likes", label: LIKES_LINKEDIN, sortable: true },
  { key: "reactions", label: REACTIONS_LINKEDIN, sortable: true },
  { key: "shares", label: SHARES_LINKEDIN, sortable: true },
  {
    key: "totalEngagements",
    label: TOTAL_ENGAGEMENTS_LINKEDIN,
    sortable: true,
  },
  {
    key: "videoCompletions",
    label: VIDEO_COMPLETIONS_LINKEDIN,
    sortable: true,
  },
  { key: "videoStarts", label: VIDEO_STARTS_LINKEDIN, sortable: true },
  { key: "videoViews", label: VIDEO_VIEWS_LINKEDIN, sortable: true },
];

export const TABLE_COLUMNS_CONFIG = {
  [GOOGLE]: [
    { key: "platform", label: COLUMN_NAME_PLATFORM },
    { key: "spend", label: COLUMN_NAME_SPEND, sortable: true },
    { key: "impressions", label: COLUMN_NAME_IMPRESSIONS, sortable: true },
    { key: "click", label: COLUMN_NAME_CLICKS, sortable: true },
    { key: "ctr", label: COLUMN_NAME_CTR, sortable: true },
    { key: "mainAction", label: COLUMN_NAME_RESULTS, sortable: true },
    { key: "costPerMainAction", label: COLUMN_NAME_CPA, sortable: true },
    { key: "cpc", label: CPC_METRICS, sortable: true },
    { key: "cpm", label: CPM_METRICS, sortable: true },
    { key: "allConversions", label: ALL_CONVERSIONS, sortable: true },
    {
      key: "allConversionsFromInteractionsRate",
      label: ALL_CONVERSIONS_FROM_INTERACTIONS_RATE,
      sortable: true,
    },
    {
      key: "allConversionsValue",
      label: ALL_CONVERSIONS_VALUE,
      sortable: true,
    },
    { key: "appEventAddToCart", label: APP_EVENT_ADD_TO_CART, sortable: true },
    { key: "appInstall", label: APP_INSTALL, sortable: true },
    { key: "averageCartSize", label: AVERAGE_CART_SIZE, sortable: true },
    { key: "averageCost", label: AVERAGE_COST, sortable: true },
    { key: "averageCpc", label: AVERAGE_CPC, sortable: true },
    {
      key: "averageOrderValueMicros",
      label: AVERAGE_ORDER_VALUE_MICROS,
      sortable: true,
    },
    { key: "checkout", label: CHECKOUT, sortable: true },
    { key: "comments", label: COMMENTS_METRICS, sortable: true },
    { key: "conversionRate", label: CONVERSION_RATE, sortable: true },
    {
      key: "conversionsFromInteractionsRate",
      label: CONVERSIONS_FROM_INTERACTIONS_RATE,
      sortable: true,
    },
    { key: "conversionsValue", label: CONVERSIONS_VALUE, sortable: true },
    {
      key: "costOfGoodsSoldMicros",
      label: COST_OF_GOODS_SOLD_MICROS,
      sortable: true,
    },
    {
      key: "costPerAllConversions",
      label: COST_PER_ALL_CONVERSIONS,
      sortable: true,
    },
    {
      key: "costPerAppEventAddToCart",
      label: COST_PER_APP_EVENT_ADD_TO_CART,
      sortable: true,
    },
    { key: "costPerAppInstall", label: COST_PER_APP_INSTALL, sortable: true },
    { key: "costPerCheckout", label: COST_PER_CHECKOUT, sortable: true },
    { key: "costPerConversion", label: COST_PER_CONVERSION, sortable: true },
    { key: "costPerPurchase", label: COST_PER_PURCHASE, sortable: true },
    { key: "costPerViewContent", label: COST_PER_VIEW_CONTENT, sortable: true },
    {
      key: "crossDeviceConversions",
      label: CROSS_DEVICE_CONVERSIONS,
      sortable: true,
    },
    {
      key: "crossDeviceConversionsValueMicros",
      label: CROSS_DEVICE_CONVERSIONS_VALUE_MICROS,
      sortable: true,
    },
    {
      key: "crossSellCostOfGoodsSoldMicros",
      label: CROSS_SELL_COST_OF_GOODS_SOLD_MICROS,
      sortable: true,
    },
    {
      key: "crossSellGrossProfitMicros",
      label: CROSS_SELL_GROSS_PROFIT_MICROS,
      sortable: true,
    },
    {
      key: "crossSellRevenueMicros",
      label: CROSS_SELL_REVENUE_MICROS,
      sortable: true,
    },
    { key: "crossSellUnitsSold", label: CROSS_SELL_UNITS_SOLD, sortable: true },
    { key: "engagementRate", label: ENGAGEMENT_RATE, sortable: true },
    { key: "follows", label: FOLLOWS, sortable: true },
    { key: "grossProfitMargin", label: GROSS_PROFIT_MARGIN, sortable: true },
    { key: "grossProfitMicros", label: GROSS_PROFIT_MICROS, sortable: true },
    { key: "interactionRate", label: INTERACTION_RATE, sortable: true },
    { key: "interactions", label: INTERACTIONS_METRICS, sortable: true },
    {
      key: "leadCostOfGoodsSoldMicros",
      label: LEAD_COST_OF_GOODS_SOLD_MICROS,
      sortable: true,
    },
    {
      key: "leadGrossProfitMicros",
      label: LEAD_GROSS_PROFIT_MICROS,
      sortable: true,
    },
    { key: "leadRevenueMicros", label: LEAD_REVENUE_MICROS, sortable: true },
    { key: "leadUnitsSold", label: LEAD_UNITS_SOLD, sortable: true },
    { key: "likes", label: LIKES_METRICS, sortable: true },
    { key: "orders", label: ORDERS_METRICS, sortable: true },
    { key: "profileVisits", label: PROFILE_VISITS, sortable: true },
    { key: "purchase", label: PURCHASE, sortable: true },
    { key: "revenueMicros", label: REVENUE_MICROS, sortable: true },
    { key: "shares", label: SHARES_METRICS, sortable: true },
    {
      key: "valuePerAllConversions",
      label: VALUE_PER_ALL_CONVERSIONS,
      sortable: true,
    },
    { key: "valuePerConversion", label: VALUE_PER_CONVERSION, sortable: true },
    { key: "videoViewsP100", label: VIDEO_VIEWS_P100, sortable: true },
    { key: "viewContent", label: VIEW_CONTENT, sortable: true },
    {
      key: "viewThroughConversions",
      label: VIEW_THROUGH_CONVERSIONS,
      sortable: true,
    },
  ],
  [META]: [
    { key: "platform", label: COLUMN_NAME_PLATFORM },
    { key: "spend", label: COLUMN_NAME_SPEND, sortable: true },
    { key: "impressions", label: COLUMN_NAME_IMPRESSIONS, sortable: true },
    { key: "click", label: COLUMN_NAME_CLICKS, sortable: true },
    { key: "ctr", label: COLUMN_NAME_CTR, sortable: true },
    { key: "mainAction", label: COLUMN_NAME_RESULTS, sortable: true },
    { key: "costPerMainAction", label: COLUMN_NAME_CPA, sortable: true },
    { key: "cpc", label: CPC_METRICS, sortable: true },
    { key: "cpm", label: CPM_METRICS, sortable: true },
    { key: "frequency", label: FREQUENCY, sortable: true },
    { key: "cpp", label: CPP, sortable: true },
    {
      key: "estimatedAdRecallers",
      label: ESTIMATED_AD_RECALLERS,
      sortable: true,
    },
    {
      key: "costPerEstimatedAdRecallers",
      label: COST_PER_ESTIMATED_AD_RECALLERS,
      sortable: true,
    },
    {
      key: "costPerInlineLinkClick",
      label: COST_PER_INLINE_LINK_CLICK,
      sortable: true,
    },
    {
      key: "costPerInlinePostEngagement",
      label: COST_PER_INLINE_POST_ENGAGEMENT,
      sortable: true,
    },
    { key: "costPerUniqueClick", label: COST_PER_UNIQUE_CLICK, sortable: true },
    {
      key: "costPerUniqueInlineLinkClick",
      label: COST_PER_UNIQUE_INLINE_LINK_CLICK,
      sortable: true,
    },
    {
      key: "costPerUniqueOutboundClick",
      label: COST_PER_UNIQUE_OUTBOUND_CLICK,
      sortable: true,
    },
    { key: "costPerThruplay", label: COST_PER_THRUPLAY, sortable: true },
    {
      key: "costPer_15SecVideoView",
      label: COST_PER_15_SEC_VIDEO_VIEW,
      sortable: true,
    },
    { key: "costPerResult", label: COST_PER_RESULT, sortable: true },
    {
      key: "costPerUniqueActionType",
      label: COST_PER_UNIQUE_ACTION_TYPE,
      sortable: true,
    },
    {
      key: "costPerOutboundClick",
      label: COST_PER_OUTBOUND_CLICK,
      sortable: true,
    },
    { key: "costPerActionType", label: COST_PER_ACTION_TYPE, sortable: true },
    { key: "actions", label: ACTIONS_METRICS, sortable: true },
    { key: "outboundClicks", label: OUTBOUND_CLICKS, sortable: true },
    { key: "outboundClicksCtr", label: OUTBOUND_CLICKS_CTR, sortable: true },
    { key: "inlineLinkClicks", label: INLINE_LINK_CLICKS, sortable: true },
    { key: "inlineLinkClickCtr", label: INLINE_LINK_CLICK_CTR, sortable: true },
    {
      key: "inlinePostEngagement",
      label: INLINE_POST_ENGAGEMENT,
      sortable: true,
    },
    { key: "resultRate", label: RESULT_RATE, sortable: true },
    { key: "results", label: RESULTS_METRICS, sortable: true },
    { key: "roas", label: ROAS_METRICS, sortable: true },
    { key: "socialSpend", label: SOCIAL_SPEND, sortable: true },
    {
      key: "shopsAssistedPurchases",
      label: SHOPS_ASSISTED_PURCHASES,
      sortable: true,
    },
    {
      key: "marketingMessagesDeliveryRate",
      label: MARKETING_MESSAGES_DELIVERY_RATE,
      sortable: true,
    },
    {
      key: "fullViewImpressions",
      label: FULL_VIEW_IMPRESSIONS,
      sortable: true,
    },
    { key: "fullViewReach", label: FULL_VIEW_REACH, sortable: true },
    { key: "videoPlayActions", label: VIDEO_PLAY_ACTIONS, sortable: true },
    {
      key: "videoAvgTimeWatchedActions",
      label: VIDEO_AVG_TIME_WATCHED_ACTIONS,
      sortable: true,
    },
    {
      key: "videoP25WatchedActions",
      label: VIDEO_P25_WATCHED_ACTIONS,
      sortable: true,
    },
    {
      key: "videoP50WatchedActions",
      label: VIDEO_P50_WATCHED_ACTIONS,
      sortable: true,
    },
    {
      key: "videoP75WatchedActions",
      label: VIDEO_P75_WATCHED_ACTIONS,
      sortable: true,
    },
    {
      key: "videoP95WatchedActions",
      label: VIDEO_P95_WATCHED_ACTIONS,
      sortable: true,
    },
    {
      key: "videoP100WatchedActions",
      label: VIDEO_P100_WATCHED_ACTIONS,
      sortable: true,
    },
    {
      key: "video_30SecWatchedActions",
      label: VIDEO_30_SEC_WATCHED_ACTIONS,
      sortable: true,
    },
    { key: "websiteCtr", label: WEBSITE_CTR, sortable: true },
    { key: "actionValues", label: ACTION_VALUES, sortable: true },
    { key: "adClickActions", label: AD_CLICK_ACTIONS, sortable: true },
    {
      key: "adImpressionActions",
      label: AD_IMPRESSION_ACTIONS,
      sortable: true,
    },
    { key: "auctionBid", label: AUCTION_BID, sortable: true },
    {
      key: "auctionCompetitiveness",
      label: AUCTION_COMPETITIVENESS,
      sortable: true,
    },
    {
      key: "auctionMaxCompetitorBid",
      label: AUCTION_MAX_COMPETITOR_BID,
      sortable: true,
    },
    {
      key: "canvasAvgViewPercent",
      label: CANVAS_AVG_VIEW_PERCENT,
      sortable: true,
    },
    { key: "canvasAvgViewTime", label: CANVAS_AVG_VIEW_TIME, sortable: true },
    {
      key: "catalogSegmentActions",
      label: CATALOG_SEGMENT_ACTIONS,
      sortable: true,
    },
    {
      key: "catalogSegmentValue",
      label: CATALOG_SEGMENT_VALUE,
      sortable: true,
    },
    {
      key: "catalogSegmentValueMobilePurchaseRoas",
      label: CATALOG_SEGMENT_VALUE_MOBILE_PURCHASE_ROAS,
      sortable: true,
    },
    {
      key: "catalogSegmentValueOmniPurchaseRoas",
      label: CATALOG_SEGMENT_VALUE_OMNI_PURCHASE_ROAS,
      sortable: true,
    },
    {
      key: "catalogSegmentValueWebsitePurchaseRoas",
      label: CATALOG_SEGMENT_VALUE_WEBSITE_PURCHASE_ROAS,
      sortable: true,
    },
    { key: "conversionValues", label: CONVERSION_VALUES, sortable: true },
    {
      key: "convertedProductAppCustomEventFbMobilePurchase",
      label: CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE,
      sortable: true,
    },
    {
      key: "convertedProductAppCustomEventFbMobilePurchaseValue",
      label: CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE,
      sortable: true,
    },
    {
      key: "convertedProductOfflinePurchase",
      label: CONVERTED_PRODUCT_OFFLINE_PURCHASE,
      sortable: true,
    },
    {
      key: "convertedProductOfflinePurchaseValue",
      label: CONVERTED_PRODUCT_OFFLINE_PURCHASE_VALUE,
      sortable: true,
    },
    {
      key: "convertedProductOmniPurchase",
      label: CONVERTED_PRODUCT_OMNI_PURCHASE,
      sortable: true,
    },
    {
      key: "convertedProductOmniPurchaseValues",
      label: CONVERTED_PRODUCT_OMNI_PURCHASE_VALUES,
      sortable: true,
    },
    {
      key: "convertedProductQuantity",
      label: CONVERTED_PRODUCT_QUANTITY,
      sortable: true,
    },
    {
      key: "convertedProductValue",
      label: CONVERTED_PRODUCT_VALUE,
      sortable: true,
    },
    {
      key: "convertedProductWebsitePixelPurchase",
      label: CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE,
      sortable: true,
    },
    {
      key: "convertedProductWebsitePixelPurchaseValue",
      label: CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE,
      sortable: true,
    },
    {
      key: "convertedPromotedProductAppCustomEventFbMobilePurchase",
      label: CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE,
      sortable: true,
    },
    {
      key: "convertedPromotedProductAppCustomEventFbMobilePurchaseValue",
      label:
        CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE,
      sortable: true,
    },
    {
      key: "convertedPromotedProductOfflinePurchase",
      label: CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE,
      sortable: true,
    },
    {
      key: "convertedPromotedProductOfflinePurchaseValue",
      label: CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE_VALUE,
      sortable: true,
    },
    {
      key: "convertedPromotedProductOmniPurchase",
      label: CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE,
      sortable: true,
    },
    {
      key: "convertedPromotedProductOmniPurchaseValues",
      label: CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE_VALUES,
      sortable: true,
    },
    {
      key: "convertedPromotedProductQuantity",
      label: CONVERTED_PROMOTED_PRODUCT_QUANTITY,
      sortable: true,
    },
    {
      key: "convertedPromotedProductValue",
      label: CONVERTED_PROMOTED_PRODUCT_VALUE,
      sortable: true,
    },
    {
      key: "convertedPromotedProductWebsitePixelPurchase",
      label: CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE,
      sortable: true,
    },
    {
      key: "convertedPromotedProductWebsitePixelPurchaseValue",
      label: CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE,
      sortable: true,
    },
    {
      key: "costPer15SecVideoView",
      label: COST_PER_15SEC_VIDEO_VIEW,
      sortable: true,
    },
    {
      key: "costPer2SecContinuousVideoView",
      label: COST_PER_2SEC_CONTINUOUS_VIDEO_VIEW,
      sortable: true,
    },
    { key: "costPerAdClick", label: COST_PER_AD_CLICK, sortable: true },
    {
      key: "costPerDdaCountbyConvs",
      label: COST_PER_DDA_COUNT_BY_CONVS,
      sortable: true,
    },
    {
      key: "costPerOneThousandAdImpression",
      label: COST_PER_ONE_THOUSAND_AD_IMPRESSION,
      sortable: true,
    },
    {
      key: "costPerObjectiveResult",
      label: COST_PER_OBJECTIVE_RESULT,
      sortable: true,
    },
    {
      key: "costPerUniqueConversion",
      label: COST_PER_UNIQUE_CONVERSION,
      sortable: true,
    },
    { key: "ddaCountbyConvs", label: DDA_COUNT_BY_CONVS, sortable: true },
    { key: "ddaResults", label: DDA_RESULTS, sortable: true },
    {
      key: "instantExperienceClicksToOpen",
      label: INSTANT_EXPERIENCE_CLICKS_TO_OPEN,
      sortable: true,
    },
    {
      key: "instantExperienceClicksToStart",
      label: INSTANT_EXPERIENCE_CLICKS_TO_START,
      sortable: true,
    },
    {
      key: "instantExperienceOutboundClicks",
      label: INSTANT_EXPERIENCE_OUTBOUND_CLICKS,
      sortable: true,
    },
    {
      key: "interactiveComponentTap",
      label: INTERACTIVE_COMPONENT_TAP,
      sortable: true,
    },
    {
      key: "landingPageViewPerLinkClick",
      label: LANDING_PAGE_VIEW_PER_LINK_CLICK,
      sortable: true,
    },
    {
      key: "objectiveResultRate",
      label: OBJECTIVE_RESULT_RATE,
      sortable: true,
    },
    { key: "objectiveResults", label: OBJECTIVE_RESULTS, sortable: true },
    {
      key: "purchasePerLandingPageView",
      label: PURCHASE_PER_LANDING_PAGE_VIEW,
      sortable: true,
    },
    {
      key: "qualifyingQuestionQualifyAnswerRate",
      label: QUALIFYING_QUESTION_QUALIFY_ANSWER_RATE,
      sortable: true,
    },
    { key: "totalCardView", label: TOTAL_CARD_VIEW, sortable: true },
    {
      key: "video30SecWatchedActions",
      label: VIDEO_30SEC_WATCHED_ACTIONS,
      sortable: true,
    },
    {
      key: "videoContinuous2SecWatchedActions",
      label: VIDEO_CONTINUOUS_2SEC_WATCHED_ACTIONS,
      sortable: true,
    },
    {
      key: "videoPlayCurveActions",
      label: VIDEO_PLAY_CURVE_ACTIONS,
      sortable: true,
    },
    {
      key: "videoPlayRetention0To15sActions",
      label: VIDEO_PLAY_RETENTION_0_TO_15S_ACTIONS,
      sortable: true,
    },
    {
      key: "videoPlayRetention20To60sActions",
      label: VIDEO_PLAY_RETENTION_20_TO_60S_ACTIONS,
      sortable: true,
    },
    {
      key: "videoHookRate",
      label: VIDEO_HOOK_RATE,
      sortable: true,
    },
    {
      key: "videoRetentionRate",
      label: VIDEO_RETENTION_RATE,
      sortable: true,
    },
    {
      key: "videoPlayRetentionGraphActions",
      label: VIDEO_PLAY_RETENTION_GRAPH_ACTIONS,
      sortable: true,
    },
    {
      key: "videoTimeWatchedActions",
      label: VIDEO_TIME_WATCHED_ACTIONS,
      sortable: true,
    },
    {
      key: "websitePurchaseRoas",
      label: WEBSITE_PURCHASE_ROAS,
      sortable: true,
    },
  ],
  [TIKTOK]: [
    { key: "platform", label: COLUMN_NAME_PLATFORM },
    { key: "spend", label: COLUMN_NAME_SPEND, sortable: true },
    { key: "impressions", label: COLUMN_NAME_IMPRESSIONS, sortable: true },
    { key: "click", label: COLUMN_NAME_CLICKS, sortable: true },
    { key: "ctr", label: COLUMN_NAME_CTR, sortable: true },
    { key: "mainAction", label: COLUMN_NAME_RESULTS, sortable: true },
    { key: "costPerMainAction", label: COLUMN_NAME_CPA, sortable: true },
    { key: "cpc", label: CPC_METRICS, sortable: true },
    { key: "cpm", label: CPM_METRICS, sortable: true },

    { key: "resultRate", label: RESULT_RATE, sortable: true },
    { key: "costPerAppInstall", label: COST_PER_APP_INSTALL, sortable: true },
    {
      key: "costPerAppEventAddToCart",
      label: COST_PER_APP_EVENT_ADD_TO_CART,
      sortable: true,
    },
    { key: "costPerCheckout", label: COST_PER_CHECKOUT, sortable: true },
    {
      key: "costPerViewContent",
      label: COST_PER_VIEW_CONTENT,
      sortable: true,
    },

    { key: "billedCost", label: BILLED_COST, sortable: true },
    { key: "grossImpressions", label: GROSS_IMPRESSIONS, sortable: true },
    { key: "conversionRate", label: CONVERSION_RATE, sortable: true },
    { key: "videoViewsP100", label: VIDEO_VIEWS_P100, sortable: true },
    { key: "averageVideoPlay", label: AVERAGE_VIDEO_PLAY, sortable: true },
    { key: "engagementRate", label: ENGAGEMENT_RATE, sortable: true },
    { key: "follows", label: FOLLOWS, sortable: true },
    { key: "likes", label: LIKES, sortable: true },
    { key: "comments", label: COMMENTS, sortable: true },
    { key: "shares", label: SHARES, sortable: true },
    { key: "profileVisits", label: PROFILE_VISITS, sortable: true },
    { key: "liveViews", label: LIVE_VIEWS, sortable: true },
    { key: "appInstall", label: APP_INSTALL, sortable: true },
    { key: "registration", label: REGISTRATION, sortable: true },
    {
      key: "costPerRegistration",
      label: COST_PER_REGISTRATION,
      sortable: true,
    },
    { key: "purchase", label: PURCHASE, sortable: true },
    { key: "purchaseRate", label: PURCHASE_RATE, sortable: true },
    { key: "totalPurchaseValue", label: TOTAL_PURCHASE_VALUE, sortable: true },
    { key: "appEventAddToCart", label: APP_EVENT_ADD_TO_CART, sortable: true },
    { key: "checkout", label: CHECKOUT, sortable: true },
    { key: "viewContent", label: VIEW_CONTENT, sortable: true },
    { key: "nextDayOpen", label: NEXT_DAY_OPEN, sortable: true },
    { key: "day7Retention", label: DAY7_RETENTION, sortable: true },
    { key: "cashSpend", label: CASH_SPEND, sortable: true },
    { key: "voucherSpend", label: VOUCHER_SPEND, sortable: true },
    { key: "costPer1000Reached", label: COST_PER_1000_REACHED, sortable: true },
    { key: "conversionRateV2", label: CONVERSION_RATE_V2, sortable: true },
    { key: "realTimeConversion", label: REAL_TIME_CONVERSION, sortable: true },
    {
      key: "realTimeCostPerConversion",
      label: REAL_TIME_COST_PER_CONVERSION,
      sortable: true,
    },
    {
      key: "realTimeConversionRate",
      label: REAL_TIME_CONVERSION_RATE,
      sortable: true,
    },
    {
      key: "realTimeConversionRateV2",
      label: REAL_TIME_CONVERSION_RATE_V2,
      sortable: true,
    },
    { key: "realTimeResult", label: REAL_TIME_RESULT, sortable: true },
    {
      key: "realTimeCostPerResult",
      label: REAL_TIME_COST_PER_RESULT,
      sortable: true,
    },
    { key: "realTimeResultRate", label: REAL_TIME_RESULT_RATE, sortable: true },
    {
      key: "secondaryGoalResult",
      label: SECONDARY_GOAL_RESULT,
      sortable: true,
    },
    {
      key: "costPerSecondaryGoalResult",
      label: COST_PER_SECONDARY_GOAL_RESULT,
      sortable: true,
    },
    {
      key: "secondaryGoalResultRate",
      label: SECONDARY_GOAL_RESULT_RATE,
      sortable: true,
    },
    { key: "videoWatched2s", label: VIDEO_WATCHED_2S, sortable: true },
    { key: "videoWatched6s", label: VIDEO_WATCHED_6S, sortable: true },
    { key: "videoViewsP25", label: VIDEO_VIEWS_P25, sortable: true },
    { key: "videoViewsP50", label: VIDEO_VIEWS_P50, sortable: true },
    { key: "videoViewsP75", label: VIDEO_VIEWS_P75, sortable: true },
    {
      key: "averageVideoPlayPerUser",
      label: AVERAGE_VIDEO_PLAY_PER_USER,
      sortable: true,
    },
    { key: "paidEngagedView", label: PAID_ENGAGED_VIEW, sortable: true },
    {
      key: "paidEngagementEngagedView",
      label: PAID_ENGAGEMENT_ENGAGED_VIEW,
      sortable: true,
    },
    { key: "engagedView15s", label: ENGAGED_VIEW_15S, sortable: true },
    { key: "paidEngagedView15s", label: PAID_ENGAGED_VIEW_15S, sortable: true },
    {
      key: "paidEngagementEngagedView15s",
      label: PAID_ENGAGEMENT_ENGAGED_VIEW_15S,
      sortable: true,
    },
    { key: "clicksOnMusicDisc", label: CLICKS_ON_MUSIC_DISC, sortable: true },
    { key: "duetClicks", label: DUET_CLICKS, sortable: true },
    { key: "stitchClicks", label: STITCH_CLICKS, sortable: true },
    { key: "soundUsageClicks", label: SOUND_USAGE_CLICKS, sortable: true },
    { key: "anchorClicks", label: ANCHOR_CLICKS, sortable: true },
    { key: "anchorClickRate", label: ANCHOR_CLICK_RATE, sortable: true },
    {
      key: "clicksOnHashtagChallenge",
      label: CLICKS_ON_HASHTAG_CHALLENGE,
      sortable: true,
    },
    { key: "profileVisitsRate", label: PROFILE_VISITS_RATE, sortable: true },
    { key: "ttPlaylistVisit", label: TT_PLAYLIST_VISIT, sortable: true },
    {
      key: "ttPlaylistVisitRate",
      label: TT_PLAYLIST_VISIT_RATE,
      sortable: true,
    },
    { key: "liveUniqueViews", label: LIVE_UNIQUE_VIEWS, sortable: true },
    { key: "liveEffectiveViews", label: LIVE_EFFECTIVE_VIEWS, sortable: true },
    { key: "liveProductClicks", label: LIVE_PRODUCT_CLICKS, sortable: true },
    {
      key: "interactiveAddOnImpressions",
      label: INTERACTIVE_ADD_ON_IMPRESSIONS,
      sortable: true,
    },
    {
      key: "interactiveAddOnDestinationClicks",
      label: INTERACTIVE_ADD_ON_DESTINATION_CLICKS,
      sortable: true,
    },
    {
      key: "interactiveAddOnActivityClicks",
      label: INTERACTIVE_ADD_ON_ACTIVITY_CLICKS,
      sortable: true,
    },
    {
      key: "interactiveAddOnOptionAClicks",
      label: INTERACTIVE_ADD_ON_OPTION_A_CLICKS,
      sortable: true,
    },
    {
      key: "interactiveAddOnOptionBClicks",
      label: INTERACTIVE_ADD_ON_OPTION_B_CLICKS,
      sortable: true,
    },
    {
      key: "countdownStickerRecallClicks",
      label: COUNTDOWN_STICKER_RECALL_CLICKS,
      sortable: true,
    },
    { key: "ixPageDurationAvg", label: IX_PAGE_DURATION_AVG, sortable: true },
    { key: "ixPageViewrateAvg", label: IX_PAGE_VIEWRATE_AVG, sortable: true },
    { key: "ixVideoViews", label: IX_VIDEO_VIEWS, sortable: true },
    { key: "ixVideoViewsP25", label: IX_VIDEO_VIEWS_P25, sortable: true },
    { key: "ixVideoViewsP50", label: IX_VIDEO_VIEWS_P50, sortable: true },
    { key: "ixVideoViewsP75", label: IX_VIDEO_VIEWS_P75, sortable: true },
    { key: "ixVideoViewsP100", label: IX_VIDEO_VIEWS_P100, sortable: true },
    { key: "ixAverageVideoPlay", label: IX_AVERAGE_VIDEO_PLAY, sortable: true },
    { key: "realTimeAppInstall", label: REAL_TIME_APP_INSTALL, sortable: true },
    {
      key: "realTimeAppInstallCost",
      label: REAL_TIME_APP_INSTALL_COST,
      sortable: true,
    },
    { key: "registrationRate", label: REGISTRATION_RATE, sortable: true },
    { key: "totalRegistration", label: TOTAL_REGISTRATION, sortable: true },
    {
      key: "costPerTotalRegistration",
      label: COST_PER_TOTAL_REGISTRATION,
      sortable: true,
    },
    { key: "totalPurchase", label: TOTAL_PURCHASE, sortable: true },
    {
      key: "costPerTotalPurchase",
      label: COST_PER_TOTAL_PURCHASE,
      sortable: true,
    },
    {
      key: "valuePerTotalPurchase",
      label: VALUE_PER_TOTAL_PURCHASE,
      sortable: true,
    },
    { key: "totalActivePayRoas", label: TOTAL_ACTIVE_PAY_ROAS, sortable: true },
    {
      key: "totalPurchaseRoasDay0",
      label: TOTAL_PURCHASE_ROAS_DAY0,
      sortable: true,
    },
    {
      key: "totalPurchaseRoasDay2",
      label: TOTAL_PURCHASE_ROAS_DAY2,
      sortable: true,
    },
    {
      key: "totalPurchaseRoasDay6",
      label: TOTAL_PURCHASE_ROAS_DAY6,
      sortable: true,
    },
    {
      key: "totalPurchaseValueDay0",
      label: TOTAL_PURCHASE_VALUE_DAY0,
      sortable: true,
    },
    {
      key: "totalPurchaseValueDay2",
      label: TOTAL_PURCHASE_VALUE_DAY2,
      sortable: true,
    },
    {
      key: "totalPurchaseValueDay6",
      label: TOTAL_PURCHASE_VALUE_DAY6,
      sortable: true,
    },
    {
      key: "appEventAddToCartRate",
      label: APP_EVENT_ADD_TO_CART_RATE,
      sortable: true,
    },
    {
      key: "totalAppEventAddToCart",
      label: TOTAL_APP_EVENT_ADD_TO_CART,
      sortable: true,
    },
    {
      key: "costPerTotalAppEventAddToCart",
      label: COST_PER_TOTAL_APP_EVENT_ADD_TO_CART,
      sortable: true,
    },
    {
      key: "valuePerTotalAppEventAddToCart",
      label: VALUE_PER_TOTAL_APP_EVENT_ADD_TO_CART,
      sortable: true,
    },
    {
      key: "totalAppEventAddToCartValue",
      label: TOTAL_APP_EVENT_ADD_TO_CART_VALUE,
      sortable: true,
    },
    { key: "checkoutRate", label: CHECKOUT_RATE, sortable: true },
    { key: "totalCheckout", label: TOTAL_CHECKOUT, sortable: true },
    {
      key: "costPerTotalCheckout",
      label: COST_PER_TOTAL_CHECKOUT,
      sortable: true,
    },
    { key: "valuePerCheckout", label: VALUE_PER_CHECKOUT, sortable: true },
    { key: "totalCheckoutValue", label: TOTAL_CHECKOUT_VALUE, sortable: true },
    { key: "viewContentRate", label: VIEW_CONTENT_RATE, sortable: true },
    { key: "totalViewContent", label: TOTAL_VIEW_CONTENT, sortable: true },
    {
      key: "costPerTotalViewContent",
      label: COST_PER_TOTAL_VIEW_CONTENT,
      sortable: true,
    },
    {
      key: "valuePerTotalViewContent",
      label: VALUE_PER_TOTAL_VIEW_CONTENT,
      sortable: true,
    },
    {
      key: "totalViewContentValue",
      label: TOTAL_VIEW_CONTENT_VALUE,
      sortable: true,
    },
    {
      key: "costPerNextDayOpen",
      label: COST_PER_NEXT_DAY_OPEN,
      sortable: true,
    },
    { key: "nextDayOpenRate", label: NEXT_DAY_OPEN_RATE, sortable: true },
    { key: "totalNextDayOpen", label: TOTAL_NEXT_DAY_OPEN, sortable: true },
    {
      key: "costPerTotalNextDayOpen",
      label: COST_PER_TOTAL_NEXT_DAY_OPEN,
      sortable: true,
    },
    {
      key: "costPerDay7Retention",
      label: COST_PER_DAY7_RETENTION,
      sortable: true,
    },
    { key: "day7RetentionRate", label: DAY7_RETENTION_RATE, sortable: true },
    { key: "totalDay7Retention", label: TOTAL_DAY7_RETENTION, sortable: true },
    {
      key: "costPerTotalDay7Retention",
      label: COST_PER_TOTAL_DAY7_RETENTION,
      sortable: true,
    },
    {
      key: "valuePerTotalDay7Retention",
      label: VALUE_PER_TOTAL_DAY7_RETENTION,
      sortable: true,
    },
    {
      key: "totalDay7RetentionValue",
      label: TOTAL_DAY7_RETENTION_VALUE,
      sortable: true,
    },
    { key: "addPaymentInfo", label: ADD_PAYMENT_INFO, sortable: true },
    {
      key: "costPerAddPaymentInfo",
      label: COST_PER_ADD_PAYMENT_INFO,
      sortable: true,
    },
    { key: "addPaymentInfoRate", label: ADD_PAYMENT_INFO_RATE, sortable: true },
    {
      key: "totalAddPaymentInfo",
      label: TOTAL_ADD_PAYMENT_INFO,
      sortable: true,
    },
    {
      key: "costTotalAddPaymentInfo",
      label: COST_TOTAL_ADD_PAYMENT_INFO,
      sortable: true,
    },
    { key: "addToWishlist", label: ADD_TO_WISHLIST, sortable: true },
    {
      key: "costPerAddToWishlist",
      label: COST_PER_ADD_TO_WISHLIST,
      sortable: true,
    },
    { key: "addToWishlistRate", label: ADD_TO_WISHLIST_RATE, sortable: true },
    { key: "totalAddToWishlist", label: TOTAL_ADD_TO_WISHLIST, sortable: true },
    {
      key: "costPerTotalAddToWishlist",
      label: COST_PER_TOTAL_ADD_TO_WISHLIST,
      sortable: true,
    },
    {
      key: "valuePerTotalAddToWishlist",
      label: VALUE_PER_TOTAL_ADD_TO_WISHLIST,
      sortable: true,
    },
    {
      key: "totalAddToWishlistValue",
      label: TOTAL_ADD_TO_WISHLIST_VALUE,
      sortable: true,
    },
    { key: "launchApp", label: LAUNCH_APP, sortable: true },
    { key: "costPerLaunchApp", label: COST_PER_LAUNCH_APP, sortable: true },
    { key: "launchAppRate", label: LAUNCH_APP_RATE, sortable: true },
    { key: "totalLaunchApp", label: TOTAL_LAUNCH_APP, sortable: true },
    {
      key: "costPerTotalLaunchApp",
      label: COST_PER_TOTAL_LAUNCH_APP,
      sortable: true,
    },
    { key: "completeTutorial", label: COMPLETE_TUTORIAL, sortable: true },
    {
      key: "costPerCompleteTutorial",
      label: COST_PER_COMPLETE_TUTORIAL,
      sortable: true,
    },
    {
      key: "completeTutorialRate",
      label: COMPLETE_TUTORIAL_RATE,
      sortable: true,
    },
    {
      key: "totalCompleteTutorial",
      label: TOTAL_COMPLETE_TUTORIAL,
      sortable: true,
    },
    {
      key: "costPerTotalCompleteTutorial",
      label: COST_PER_TOTAL_COMPLETE_TUTORIAL,
      sortable: true,
    },
    {
      key: "valuePerTotalCompleteTutorial",
      label: VALUE_PER_TOTAL_COMPLETE_TUTORIAL,
      sortable: true,
    },
    {
      key: "totalCompleteTutorialValue",
      label: TOTAL_COMPLETE_TUTORIAL_VALUE,
      sortable: true,
    },
    { key: "createGroup", label: CREATE_GROUP, sortable: true },
    { key: "costPerCreateGroup", label: COST_PER_CREATE_GROUP, sortable: true },
    { key: "createGroupRate", label: CREATE_GROUP_RATE, sortable: true },
    { key: "totalCreateGroup", label: TOTAL_CREATE_GROUP, sortable: true },
    {
      key: "costPerTotalCreateGroup",
      label: COST_PER_TOTAL_CREATE_GROUP,
      sortable: true,
    },
    {
      key: "valuePerTotalCreateGroup",
      label: VALUE_PER_TOTAL_CREATE_GROUP,
      sortable: true,
    },
    {
      key: "totalCreateGroupValue",
      label: TOTAL_CREATE_GROUP_VALUE,
      sortable: true,
    },
    { key: "joinGroup", label: JOIN_GROUP, sortable: true },
    { key: "costPerJoinGroup", label: COST_PER_JOIN_GROUP, sortable: true },
    { key: "joinGroupRate", label: JOIN_GROUP_RATE, sortable: true },
    { key: "totalJoinGroup", label: TOTAL_JOIN_GROUP, sortable: true },
    {
      key: "costPerTotalJoinGroup",
      label: COST_PER_TOTAL_JOIN_GROUP,
      sortable: true,
    },
    {
      key: "valuePerTotalJoinGroup",
      label: VALUE_PER_TOTAL_JOIN_GROUP,
      sortable: true,
    },
    {
      key: "totalJoinGroupValue",
      label: TOTAL_JOIN_GROUP_VALUE,
      sortable: true,
    },
    { key: "createGamerole", label: CREATE_GAMEROLE, sortable: true },
    {
      key: "costPerCreateGamerole",
      label: COST_PER_CREATE_GAMEROLE,
      sortable: true,
    },
    { key: "createGameroleRate", label: CREATE_GAMEROLE_RATE, sortable: true },
    {
      key: "totalCreateGamerole",
      label: TOTAL_CREATE_GAMEROLE,
      sortable: true,
    },
    {
      key: "costPerTotalCreateGamerole",
      label: COST_PER_TOTAL_CREATE_GAMEROLE,
      sortable: true,
    },
    {
      key: "valuePerTotalCreateGamerole",
      label: VALUE_PER_TOTAL_CREATE_GAMEROLE,
      sortable: true,
    },
    {
      key: "totalCreateGameroleValue",
      label: TOTAL_CREATE_GAMEROLE_VALUE,
      sortable: true,
    },
    { key: "spendCredits", label: SPEND_CREDITS, sortable: true },
    {
      key: "costPerSpendCredits",
      label: COST_PER_SPEND_CREDITS,
      sortable: true,
    },
    { key: "spendCreditsRate", label: SPEND_CREDITS_RATE, sortable: true },
    { key: "totalSpendCredits", label: TOTAL_SPEND_CREDITS, sortable: true },
    {
      key: "costPerTotalSpendCredits",
      label: COST_PER_TOTAL_SPEND_CREDITS,
      sortable: true,
    },
    {
      key: "valuePerTotalSpendCredits",
      label: VALUE_PER_TOTAL_SPEND_CREDITS,
      sortable: true,
    },
    {
      key: "totalSpendCreditsValue",
      label: TOTAL_SPEND_CREDITS_VALUE,
      sortable: true,
    },
    { key: "achieveLevel", label: ACHIEVE_LEVEL, sortable: true },
    {
      key: "costPerAchieveLevel",
      label: COST_PER_ACHIEVE_LEVEL,
      sortable: true,
    },
    { key: "achieveLevelRate", label: ACHIEVE_LEVEL_RATE, sortable: true },
    { key: "totalAchieveLevel", label: TOTAL_ACHIEVE_LEVEL, sortable: true },
    {
      key: "costPerTotalAchieveLevel",
      label: COST_PER_TOTAL_ACHIEVE_LEVEL,
      sortable: true,
    },
    {
      key: "valuePerTotalAchieveLevel",
      label: VALUE_PER_TOTAL_ACHIEVE_LEVEL,
      sortable: true,
    },
    {
      key: "totalAchieveLevelValue",
      label: TOTAL_ACHIEVE_LEVEL_VALUE,
      sortable: true,
    },
    { key: "unlockAchievement", label: UNLOCK_ACHIEVEMENT, sortable: true },
    {
      key: "costPerUnlockAchievement",
      label: COST_PER_UNLOCK_ACHIEVEMENT,
      sortable: true,
    },
    {
      key: "unlockAchievementRate",
      label: UNLOCK_ACHIEVEMENT_RATE,
      sortable: true,
    },
    {
      key: "totalUnlockAchievement",
      label: TOTAL_UNLOCK_ACHIEVEMENT,
      sortable: true,
    },
    {
      key: "costPerTotalUnlockAchievement",
      label: COST_PER_TOTAL_UNLOCK_ACHIEVEMENT,
      sortable: true,
    },
    {
      key: "valuePerTotalUnlockAchievement",
      label: VALUE_PER_TOTAL_UNLOCK_ACHIEVEMENT,
      sortable: true,
    },
    {
      key: "totalUnlockAchievementValue",
      label: TOTAL_UNLOCK_ACHIEVEMENT_VALUE,
      sortable: true,
    },
    { key: "salesLead", label: SALES_LEAD, sortable: true },
    { key: "costPerSalesLead", label: COST_PER_SALES_LEAD, sortable: true },
    { key: "salesLeadRate", label: SALES_LEAD_RATE, sortable: true },
    { key: "totalSalesLead", label: TOTAL_SALES_LEAD, sortable: true },
    {
      key: "costPerTotalSalesLead",
      label: COST_PER_TOTAL_SALES_LEAD,
      sortable: true,
    },
    {
      key: "valuePerTotalSalesLead",
      label: VALUE_PER_TOTAL_SALES_LEAD,
      sortable: true,
    },
    {
      key: "totalSalesLeadValue",
      label: TOTAL_SALES_LEAD_VALUE,
      sortable: true,
    },
    { key: "inAppAdClick", label: IN_APP_AD_CLICK, sortable: true },
    {
      key: "costPerInAppAdClick",
      label: COST_PER_IN_APP_AD_CLICK,
      sortable: true,
    },
    { key: "inAppAdClickRate", label: IN_APP_AD_CLICK_RATE, sortable: true },

    { key: "totalInAppAdClick", label: TOTAL_IN_APP_AD_CLICK, sortable: true },
    {
      key: "costPerTotalInAppAdClick",
      label: COST_PER_TOTAL_IN_APP_AD_CLICK,
      sortable: true,
    },
    {
      key: "valuePerTotalInAppAdClick",
      label: VALUE_PER_TOTAL_IN_APP_AD_CLICK,
      sortable: true,
    },
    {
      key: "totalInAppAdClickValue",
      label: TOTAL_IN_APP_AD_CLICK_VALUE,
      sortable: true,
    },
    { key: "inAppAdImpr", label: IN_APP_AD_IMPR, sortable: true },
    {
      key: "costPerInAppAdImpr",
      label: COST_PER_IN_APP_AD_IMPR,
      sortable: true,
    },
    { key: "inAppAdImprRate", label: IN_APP_AD_IMPR_RATE, sortable: true },
    { key: "totalInAppAdImpr", label: TOTAL_IN_APP_AD_IMPR, sortable: true },
    {
      key: "costPerTotalInAppAdImpr",
      label: COST_PER_TOTAL_IN_APP_AD_IMPR,
      sortable: true,
    },
    {
      key: "valuePerTotalInAppAdImpr",
      label: VALUE_PER_TOTAL_IN_APP_AD_IMPR,
      sortable: true,
    },
    {
      key: "totalInAppAdImprValue",
      label: TOTAL_IN_APP_AD_IMPR_VALUE,
      sortable: true,
    },
    { key: "loanApply", label: LOAN_APPLY, sortable: true },
    { key: "costPerLoanApply", label: COST_PER_LOAN_APPLY, sortable: true },
    { key: "loanApplyRate", label: LOAN_APPLY_RATE, sortable: true },
    { key: "totalLoanApply", label: TOTAL_LOAN_APPLY, sortable: true },
    {
      key: "costPerTotalLoanApply",
      label: COST_PER_TOTAL_LOAN_APPLY,
      sortable: true,
    },
    { key: "loanCredit", label: LOAN_CREDIT, sortable: true },
    { key: "costPerLoanCredit", label: COST_PER_LOAN_CREDIT, sortable: true },
    { key: "loanCreditRate", label: LOAN_CREDIT_RATE, sortable: true },
    { key: "totalLoanCredit", label: TOTAL_LOAN_CREDIT, sortable: true },
    {
      key: "costPerTotalLoanCredit",
      label: COST_PER_TOTAL_LOAN_CREDIT,
      sortable: true,
    },
    { key: "loanDisbursement", label: LOAN_DISBURSEMENT, sortable: true },
    {
      key: "costPerLoanDisbursement",
      label: COST_PER_LOAN_DISBURSEMENT,
      sortable: true,
    },
    {
      key: "loanDisbursementRate",
      label: LOAN_DISBURSEMENT_RATE,
      sortable: true,
    },
    {
      key: "totalLoanDisbursement",
      label: TOTAL_LOAN_DISBURSEMENT,
      sortable: true,
    },
    {
      key: "costPerTotalLoanDisbursement",
      label: COST_PER_TOTAL_LOAN_DISBURSEMENT,
      sortable: true,
    },
    { key: "login", label: LOGIN, sortable: true },
    { key: "costPerLogin", label: COST_PER_LOGIN, sortable: true },
    { key: "loginRate", label: LOGIN_RATE, sortable: true },
    { key: "totalLogin", label: TOTAL_LOGIN, sortable: true },
    { key: "costPerTotalLogin", label: COST_PER_TOTAL_LOGIN, sortable: true },
    { key: "ratings", label: RATINGS, sortable: true },
    { key: "costPerRatings", label: COST_PER_RATINGS, sortable: true },
    { key: "ratingsRate", label: RATINGS_RATE, sortable: true },
    { key: "totalRatings", label: TOTAL_RATINGS, sortable: true },
    {
      key: "costPerTotalRatings",
      label: COST_PER_TOTAL_RATINGS,
      sortable: true,
    },
    {
      key: "valuePerTotalRatings",
      label: VALUE_PER_TOTAL_RATINGS,
      sortable: true,
    },
    { key: "totalRatingsValue", label: TOTAL_RATINGS_VALUE, sortable: true },
    { key: "search", label: SEARCH_TIKTOK, sortable: true },
    { key: "costPerSearch", label: COST_PER_SEARCH, sortable: true },
    { key: "searchRate", label: SEARCH_RATE, sortable: true },
    { key: "totalSearch", label: TOTAL_SEARCH, sortable: true },
    { key: "costPerTotalSearch", label: COST_PER_TOTAL_SEARCH, sortable: true },
    { key: "startTrial", label: START_TRIAL, sortable: true },
    { key: "costPerStartTrial", label: COST_PER_START_TRIAL, sortable: true },
    { key: "startTrialRate", label: START_TRIAL_RATE, sortable: true },
    { key: "totalStartTrial", label: TOTAL_START_TRIAL, sortable: true },
    {
      key: "costPerTotalStartTrial",
      label: COST_PER_TOTAL_START_TRIAL,
      sortable: true,
    },
    { key: "subscribe", label: SUBSCRIBE, sortable: true },
    { key: "costPerSubscribe", label: COST_PER_SUBSCRIBE, sortable: true },
    { key: "subscribeRate", label: SUBSCRIBE_RATE, sortable: true },
    { key: "totalSubscribe", label: TOTAL_SUBSCRIBE, sortable: true },
    {
      key: "costPerTotalSubscribe",
      label: COST_PER_TOTAL_SUBSCRIBE,
      sortable: true,
    },
    {
      key: "valuePerTotalSubscribe",
      label: VALUE_PER_TOTAL_SUBSCRIBE,
      sortable: true,
    },
    {
      key: "totalSubscribeValue",
      label: TOTAL_SUBSCRIBE_VALUE,
      sortable: true,
    },
    {
      key: "uniqueCustomAppEvents",
      label: UNIQUE_CUSTOM_APP_EVENTS,
      sortable: true,
    },
    {
      key: "costPerUniqueCustomAppEvent",
      label: COST_PER_UNIQUE_CUSTOM_APP_EVENT,
      sortable: true,
    },
    { key: "customAppEventRate", label: CUSTOM_APP_EVENT_RATE, sortable: true },
    { key: "customAppEvents", label: CUSTOM_APP_EVENTS, sortable: true },
    {
      key: "costPerCustomAppEvent",
      label: COST_PER_CUSTOM_APP_EVENT,
      sortable: true,
    },
    {
      key: "valuePerCustomAppEvent",
      label: VALUE_PER_CUSTOM_APP_EVENT,
      sortable: true,
    },
    {
      key: "customAppEventsValue",
      label: CUSTOM_APP_EVENTS_VALUE,
      sortable: true,
    },
    {
      key: "uniqueAdImpressionEvents",
      label: UNIQUE_AD_IMPRESSION_EVENTS,
      sortable: true,
    },
    {
      key: "costPerUniqueAdImpressionEvent",
      label: COST_PER_UNIQUE_AD_IMPRESSION_EVENT,
      sortable: true,
    },
    {
      key: "customizedAdImpressionEventRate",
      label: CUSTOMIZED_AD_IMPRESSION_EVENT_RATE,
      sortable: true,
    },
    {
      key: "adsImpressionEvents",
      label: ADS_IMPRESSION_EVENTS,
      sortable: true,
    },
    {
      key: "costPreAdImpressionEvent",
      label: COST_PRE_AD_IMPRESSION_EVENT,
      sortable: true,
    },
    {
      key: "valuePerAdImpressionEvent",
      label: VALUE_PER_AD_IMPRESSION_EVENT,
      sortable: true,
    },
    {
      key: "totalAdImpressionEventsValue",
      label: TOTAL_AD_IMPRESSION_EVENTS_VALUE,
      sortable: true,
    },
    {
      key: "totalAdImpressionRoas",
      label: TOTAL_AD_IMPRESSION_ROAS,
      sortable: true,
    },
    {
      key: "adImpressionAdRevenueRoasDay0",
      label: AD_IMPRESSION_AD_REVENUE_ROAS_DAY0,
      sortable: true,
    },
    {
      key: "adImpressionAdRevenueRoasDay2",
      label: AD_IMPRESSION_AD_REVENUE_ROAS_DAY2,
      sortable: true,
    },
    {
      key: "adImpressionAdRevenueRoasDay6",
      label: AD_IMPRESSION_AD_REVENUE_ROAS_DAY6,
      sortable: true,
    },
    {
      key: "adImpressionAdRevenueDay0",
      label: AD_IMPRESSION_AD_REVENUE_DAY0,
      sortable: true,
    },
    {
      key: "adImpressionAdRevenueDay2",
      label: AD_IMPRESSION_AD_REVENUE_DAY2,
      sortable: true,
    },
    {
      key: "adImpressionAdRevenueDay6",
      label: AD_IMPRESSION_AD_REVENUE_DAY6,
      sortable: true,
    },
    {
      key: "completePaymentRoas",
      label: COMPLETE_PAYMENT_ROAS,
      sortable: true,
    },
    { key: "completePayment", label: COMPLETE_PAYMENT, sortable: true },
    {
      key: "costPerCompletePayment",
      label: COST_PER_COMPLETE_PAYMENT,
      sortable: true,
    },
    {
      key: "completePaymentRate",
      label: COMPLETE_PAYMENT_RATE,
      sortable: true,
    },
    {
      key: "valuePerCompletePayment",
      label: VALUE_PER_COMPLETE_PAYMENT,
      sortable: true,
    },
    {
      key: "totalCompletePaymentRate",
      label: TOTAL_COMPLETE_PAYMENT_RATE,
      sortable: true,
    },
    {
      key: "totalLandingPageView",
      label: TOTAL_LANDING_PAGE_VIEW,
      sortable: true,
    },
    {
      key: "costPerLandingPageView",
      label: COST_PER_LANDING_PAGE_VIEW,
      sortable: true,
    },
    {
      key: "landingPageViewRate",
      label: LANDING_PAGE_VIEW_RATE,
      sortable: true,
    },
    { key: "totalPageview", label: TOTAL_PAGEVIEW, sortable: true },
    { key: "costPerPageview", label: COST_PER_PAGEVIEW, sortable: true },
    { key: "pageviewRate", label: PAGEVIEW_RATE, sortable: true },
    {
      key: "avgValuePerPageview",
      label: AVG_VALUE_PER_PAGEVIEW,
      sortable: true,
    },
    {
      key: "totalValuePerPageview",
      label: TOTAL_VALUE_PER_PAGEVIEW,
      sortable: true,
    },
    { key: "pageBrowseView", label: PAGE_BROWSE_VIEW, sortable: true },
    {
      key: "costPerPageBrowseView",
      label: COST_PER_PAGE_BROWSE_VIEW,
      sortable: true,
    },
    { key: "pageBrowseViewRate", label: PAGE_BROWSE_VIEW_RATE, sortable: true },
    {
      key: "totalPageBrowseViewValue",
      label: TOTAL_PAGE_BROWSE_VIEW_VALUE,
      sortable: true,
    },
    {
      key: "valuePerPageBrowseView",
      label: VALUE_PER_PAGE_BROWSE_VIEW,
      sortable: true,
    },
    { key: "buttonClick", label: BUTTON_CLICK, sortable: true },
    { key: "costPerButtonClick", label: COST_PER_BUTTON_CLICK, sortable: true },
    { key: "buttonClickRate", label: BUTTON_CLICK_RATE, sortable: true },
    {
      key: "valuePerButtonClick",
      label: VALUE_PER_BUTTON_CLICK,
      sortable: true,
    },
    {
      key: "totalButtonClickValue",
      label: TOTAL_BUTTON_CLICK_VALUE,
      sortable: true,
    },
    { key: "onlineConsult", label: ONLINE_CONSULT, sortable: true },
    {
      key: "costPerOnlineConsult",
      label: COST_PER_ONLINE_CONSULT,
      sortable: true,
    },
    { key: "onlineConsultRate", label: ONLINE_CONSULT_RATE, sortable: true },
    {
      key: "valuePerOnlineConsult",
      label: VALUE_PER_ONLINE_CONSULT,
      sortable: true,
    },
    {
      key: "totalOnlineConsultValue",
      label: TOTAL_ONLINE_CONSULT_VALUE,
      sortable: true,
    },
    { key: "userRegistration", label: USER_REGISTRATION, sortable: true },
    {
      key: "costPerUserRegistration",
      label: COST_PER_USER_REGISTRATION,
      sortable: true,
    },
    {
      key: "userRegistrationRate",
      label: USER_REGISTRATION_RATE,
      sortable: true,
    },
    {
      key: "valuePerUserRegistration",
      label: VALUE_PER_USER_REGISTRATION,
      sortable: true,
    },
    {
      key: "totalUserRegistrationValue",
      label: TOTAL_USER_REGISTRATION_VALUE,
      sortable: true,
    },
    {
      key: "pageContentViewEvents",
      label: PAGE_CONTENT_VIEW_EVENTS,
      sortable: true,
    },
    {
      key: "costPerPageContentViewEvent",
      label: COST_PER_PAGE_CONTENT_VIEW_EVENT,
      sortable: true,
    },
    {
      key: "pageContentViewEventRate",
      label: PAGE_CONTENT_VIEW_EVENT_RATE,
      sortable: true,
    },
    {
      key: "valuePerPageContentViewEvent",
      label: VALUE_PER_PAGE_CONTENT_VIEW_EVENT,
      sortable: true,
    },
    {
      key: "totalPageViewContentEventsValue",
      label: TOTAL_PAGE_VIEW_CONTENT_EVENTS_VALUE,
      sortable: true,
    },
    {
      key: "productDetailsPageBrowse",
      label: PRODUCT_DETAILS_PAGE_BROWSE,
      sortable: true,
    },
    {
      key: "costPerProductDetailsPageBrowse",
      label: COST_PER_PRODUCT_DETAILS_PAGE_BROWSE,
      sortable: true,
    },
    {
      key: "productDetailsPageBrowseRate",
      label: PRODUCT_DETAILS_PAGE_BROWSE_RATE,
      sortable: true,
    },
    {
      key: "valuePerProductDetailsPageBrowse",
      label: VALUE_PER_PRODUCT_DETAILS_PAGE_BROWSE,
      sortable: true,
    },
    {
      key: "totalProductDetailsPageBrowseValue",
      label: TOTAL_PRODUCT_DETAILS_PAGE_BROWSE_VALUE,
      sortable: true,
    },
    { key: "webEventAddToCart", label: WEB_EVENT_ADD_TO_CART, sortable: true },
    {
      key: "costPerWebEventAddToCart",
      label: COST_PER_WEB_EVENT_ADD_TO_CART,
      sortable: true,
    },
    {
      key: "webEventAddToCartRate",
      label: WEB_EVENT_ADD_TO_CART_RATE,
      sortable: true,
    },
    {
      key: "valuePerWebEventAddToCart",
      label: VALUE_PER_WEB_EVENT_ADD_TO_CART,
      sortable: true,
    },
    {
      key: "totalWebEventAddToCartValue",
      label: TOTAL_WEB_EVENT_ADD_TO_CART_VALUE,
      sortable: true,
    },
    { key: "onWebOrder", label: ON_WEB_ORDER, sortable: true },
    { key: "costPerOnWebOrder", label: COST_PER_ON_WEB_ORDER, sortable: true },
    { key: "onWebOrderRate", label: ON_WEB_ORDER_RATE, sortable: true },
    {
      key: "valuePerOnWebOrder",
      label: VALUE_PER_ON_WEB_ORDER,
      sortable: true,
    },
    {
      key: "totalOnWebOrderValue",
      label: TOTAL_ON_WEB_ORDER_VALUE,
      sortable: true,
    },
    { key: "initiateCheckout", label: INITIATE_CHECKOUT, sortable: true },
    {
      key: "costPerInitiateCheckout",
      label: COST_PER_INITIATE_CHECKOUT,
      sortable: true,
    },
    {
      key: "initiateCheckoutRate",
      label: INITIATE_CHECKOUT_RATE,
      sortable: true,
    },
    {
      key: "valuePerInitiateCheckout",
      label: VALUE_PER_INITIATE_CHECKOUT,
      sortable: true,
    },
    {
      key: "totalInitiateCheckoutValue",
      label: TOTAL_INITIATE_CHECKOUT_VALUE,
      sortable: true,
    },
    { key: "addBilling", label: ADD_BILLING, sortable: true },
    { key: "costPerAddBilling", label: COST_PER_ADD_BILLING, sortable: true },
    { key: "addBillingRate", label: ADD_BILLING_RATE, sortable: true },
    { key: "valuePerAddBilling", label: VALUE_PER_ADD_BILLING, sortable: true },
    {
      key: "totalAddBillingValue",
      label: TOTAL_ADD_BILLING_VALUE,
      sortable: true,
    },
    { key: "pageEventSearch", label: PAGE_EVENT_SEARCH, sortable: true },
    {
      key: "costPerPageEventSearch",
      label: COST_PER_PAGE_EVENT_SEARCH,
      sortable: true,
    },
    {
      key: "pageEventSearchRate",
      label: PAGE_EVENT_SEARCH_RATE,
      sortable: true,
    },
    {
      key: "valuePerPageEventSearch",
      label: VALUE_PER_PAGE_EVENT_SEARCH,
      sortable: true,
    },
    {
      key: "totalPageEventSearchValue",
      label: TOTAL_PAGE_EVENT_SEARCH_VALUE,
      sortable: true,
    },
    { key: "form", label: FORM_TIKTOK, sortable: true },
    { key: "costPerForm", label: COST_PER_FORM, sortable: true },
    { key: "formRate", label: FORM_RATE, sortable: true },
    { key: "valuePerForm", label: VALUE_PER_FORM, sortable: true },
    { key: "totalFormValue", label: TOTAL_FORM_VALUE, sortable: true },
    { key: "downloadStart", label: DOWNLOAD_START, sortable: true },
    {
      key: "costPerDownloadStart",
      label: COST_PER_DOWNLOAD_START,
      sortable: true,
    },
    { key: "downloadStartRate", label: DOWNLOAD_START_RATE, sortable: true },
    {
      key: "valuePerDownloadStart",
      label: VALUE_PER_DOWNLOAD_START,
      sortable: true,
    },
    {
      key: "totalDownloadStartValue",
      label: TOTAL_DOWNLOAD_START_VALUE,
      sortable: true,
    },
    {
      key: "onWebAddToWishlist",
      label: ON_WEB_ADD_TO_WISHLIST,
      sortable: true,
    },
    {
      key: "costPerOnWebAddToWishlist",
      label: COST_PER_ON_WEB_ADD_TO_WISHLIST,
      sortable: true,
    },
    {
      key: "onWebAddToWishlistPerClick",
      label: ON_WEB_ADD_TO_WISHLIST_PER_CLICK,
      sortable: true,
    },
    {
      key: "valuePerOnWebAddToWishlist",
      label: VALUE_PER_ON_WEB_ADD_TO_WISHLIST,
      sortable: true,
    },
    {
      key: "totalOnWebAddToWishlistValue",
      label: TOTAL_ON_WEB_ADD_TO_WISHLIST_VALUE,
      sortable: true,
    },
    { key: "onWebSubscribe", label: ON_WEB_SUBSCRIBE, sortable: true },
    {
      key: "costPerOnWebSubscribe",
      label: COST_PER_ON_WEB_SUBSCRIBE,
      sortable: true,
    },
    {
      key: "onWebSubscribePerClick",
      label: ON_WEB_SUBSCRIBE_PER_CLICK,
      sortable: true,
    },
    {
      key: "valuePerOnWebSubscribe",
      label: VALUE_PER_ON_WEB_SUBSCRIBE,
      sortable: true,
    },
    {
      key: "totalOnWebSubscribeValue",
      label: TOTAL_ON_WEB_SUBSCRIBE_VALUE,
      sortable: true,
    },
    {
      key: "websiteTotalFindLocation",
      label: WEBSITE_TOTAL_FIND_LOCATION,
      sortable: true,
    },
    {
      key: "websiteCostPerFindLocation",
      label: WEBSITE_COST_PER_FIND_LOCATION,
      sortable: true,
    },
    {
      key: "websiteFindLocationRate",
      label: WEBSITE_FIND_LOCATION_RATE,
      sortable: true,
    },
    {
      key: "websiteValuePerFindLocation",
      label: WEBSITE_VALUE_PER_FIND_LOCATION,
      sortable: true,
    },
    {
      key: "websiteTotalFindLocationValue",
      label: WEBSITE_TOTAL_FIND_LOCATION_VALUE,
      sortable: true,
    },
    {
      key: "websiteTotalSchedule",
      label: WEBSITE_TOTAL_SCHEDULE,
      sortable: true,
    },
    {
      key: "websiteCostPerSchedule",
      label: WEBSITE_COST_PER_SCHEDULE,
      sortable: true,
    },
    {
      key: "websiteScheduleRate",
      label: WEBSITE_SCHEDULE_RATE,
      sortable: true,
    },
    {
      key: "websiteValuePerSchedule",
      label: WEBSITE_VALUE_PER_SCHEDULE,
      sortable: true,
    },
    {
      key: "websiteTotalScheduleValue",
      label: WEBSITE_TOTAL_SCHEDULE_VALUE,
      sortable: true,
    },
    {
      key: "websiteTotalCustomizeProduct",
      label: WEBSITE_TOTAL_CUSTOMIZE_PRODUCT,
      sortable: true,
    },
    {
      key: "websiteCostPerCustomizeProduct",
      label: WEBSITE_COST_PER_CUSTOMIZE_PRODUCT,
      sortable: true,
    },
    {
      key: "websiteCustomizeProductRate",
      label: WEBSITE_CUSTOMIZE_PRODUCT_RATE,
      sortable: true,
    },
    {
      key: "websiteValuePerCustomizeProduct",
      label: WEBSITE_VALUE_PER_CUSTOMIZE_PRODUCT,
      sortable: true,
    },
    {
      key: "websiteTotalCustomizeProductValue",
      label: WEBSITE_TOTAL_CUSTOMIZE_PRODUCT_VALUE,
      sortable: true,
    },
    { key: "customPageEvents", label: CUSTOM_PAGE_EVENTS, sortable: true },
    {
      key: "costPerCustomPageEvent",
      label: COST_PER_CUSTOM_PAGE_EVENT,
      sortable: true,
    },
    {
      key: "customPageEventRate",
      label: CUSTOM_PAGE_EVENT_RATE,
      sortable: true,
    },
    {
      key: "valuePerCustomPageEvent",
      label: VALUE_PER_CUSTOM_PAGE_EVENT,
      sortable: true,
    },
    {
      key: "customPageEventsValue",
      label: CUSTOM_PAGE_EVENTS_VALUE,
      sortable: true,
    },
    {
      key: "onsitePurchasesRoas",
      label: ONSITE_PURCHASES_ROAS,
      sortable: true,
    },

    {
      key: "onsiteTotalPurchase",
      label: ONSITE_TOTAL_PURCHASE,
      sortable: true,
    },
    {
      key: "onsiteCostPerPurchase",
      label: ONSITE_COST_PER_PURCHASE,
      sortable: true,
    },
    { key: "onsitePurchaseRate", label: ONSITE_PURCHASE_RATE, sortable: true },
    {
      key: "onsiteValuePerPurchase",
      label: ONSITE_VALUE_PER_PURCHASE,
      sortable: true,
    },
    {
      key: "onsiteTotalPurchaseValue",
      label: ONSITE_TOTAL_PURCHASE_VALUE,
      sortable: true,
    },
    {
      key: "onsiteTotalCheckoutInitiation",
      label: ONSITE_TOTAL_CHECKOUT_INITIATION,
      sortable: true,
    },
    {
      key: "onsiteCostPerCheckoutInitiation",
      label: ONSITE_COST_PER_CHECKOUT_INITIATION,
      sortable: true,
    },
    {
      key: "onsiteCheckoutInitiationRate",
      label: ONSITE_CHECKOUT_INITIATION_RATE,
      sortable: true,
    },
    {
      key: "onsiteValuePerCheckoutInitiation",
      label: ONSITE_VALUE_PER_CHECKOUT_INITIATION,
      sortable: true,
    },
    {
      key: "onsiteTotalCheckoutInitiationValue",
      label: ONSITE_TOTAL_CHECKOUT_INITIATION_VALUE,
      sortable: true,
    },
    {
      key: "onsiteTotalAddToCart",
      label: ONSITE_TOTAL_ADD_TO_CART,
      sortable: true,
    },
    {
      key: "onsiteCostPerAddToCart",
      label: ONSITE_COST_PER_ADD_TO_CART,
      sortable: true,
    },
    {
      key: "onsiteAddToCartRate",
      label: ONSITE_ADD_TO_CART_RATE,
      sortable: true,
    },
    {
      key: "onsiteValuePerAddToCart",
      label: ONSITE_VALUE_PER_ADD_TO_CART,
      sortable: true,
    },
    {
      key: "onsiteTotalAddToCartValue",
      label: ONSITE_TOTAL_ADD_TO_CART_VALUE,
      sortable: true,
    },
    {
      key: "onsiteTotalProductDetailsPageView",
      label: ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW,
      sortable: true,
    },
    {
      key: "onsiteCostPerProductDetailsPageView",
      label: ONSITE_COST_PER_PRODUCT_DETAILS_PAGE_VIEW,
      sortable: true,
    },
    {
      key: "onsiteProductDetailsPageViewRate",
      label: ONSITE_PRODUCT_DETAILS_PAGE_VIEW_RATE,
      sortable: true,
    },
    {
      key: "onsiteValuePerProductDetailsPageView",
      label: ONSITE_VALUE_PER_PRODUCT_DETAILS_PAGE_VIEW,
      sortable: true,
    },
    {
      key: "onsiteTotalProductDetailsPageViewValue",
      label: ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW_VALUE,
      sortable: true,
    },
    {
      key: "onsiteAddToWishlist",
      label: ONSITE_ADD_TO_WISHLIST,
      sortable: true,
    },
    {
      key: "costPerOnsiteAddToWishlist",
      label: COST_PER_ONSITE_ADD_TO_WISHLIST,
      sortable: true,
    },
    {
      key: "onsiteAddToWishlistRate",
      label: ONSITE_ADD_TO_WISHLIST_RATE,
      sortable: true,
    },
    {
      key: "valuePerOnsiteAddToWishlist",
      label: VALUE_PER_ONSITE_ADD_TO_WISHLIST,
      sortable: true,
    },
    {
      key: "totalOnsiteAddToWishlistValue",
      label: TOTAL_ONSITE_ADD_TO_WISHLIST_VALUE,
      sortable: true,
    },
    { key: "onsiteAddBilling", label: ONSITE_ADD_BILLING, sortable: true },
    {
      key: "costPerOnsiteAddBilling",
      label: COST_PER_ONSITE_ADD_BILLING,
      sortable: true,
    },
    {
      key: "onsiteAddBillingRate",
      label: ONSITE_ADD_BILLING_RATE,
      sortable: true,
    },
    {
      key: "valuePerOnsiteAddBilling",
      label: VALUE_PER_ONSITE_ADD_BILLING,
      sortable: true,
    },
    {
      key: "totalOnsiteAddBillingValue",
      label: TOTAL_ONSITE_ADD_BILLING_VALUE,
      sortable: true,
    },
    { key: "onsiteForm", label: ONSITE_FORM, sortable: true },
    { key: "costPerOnsiteForm", label: COST_PER_ONSITE_FORM, sortable: true },
    { key: "onsiteFormRate", label: ONSITE_FORM_RATE, sortable: true },
    { key: "valuePerOnsiteForm", label: VALUE_PER_ONSITE_FORM, sortable: true },
    {
      key: "totalOnsiteFormValue",
      label: TOTAL_ONSITE_FORM_VALUE,
      sortable: true,
    },
    {
      key: "onsiteTotalFilteredOutFormSubmission",
      label: ONSITE_TOTAL_FILTERED_OUT_FORM_SUBMISSION,
      sortable: true,
    },
    {
      key: "onsiteDownloadStart",
      label: ONSITE_DOWNLOAD_START,
      sortable: true,
    },
    {
      key: "costPerOnsiteDownloadStart",
      label: COST_PER_ONSITE_DOWNLOAD_START,
      sortable: true,
    },
    {
      key: "onsiteDownloadStartRate",
      label: ONSITE_DOWNLOAD_START_RATE,
      sortable: true,
    },
    {
      key: "onsiteDestinationVisits",
      label: ONSITE_DESTINATION_VISITS,
      sortable: true,
    },
    {
      key: "costPerOnsiteDestinationVisit",
      label: COST_PER_ONSITE_DESTINATION_VISIT,
      sortable: true,
    },
    {
      key: "onsiteDestinationVisitRate",
      label: ONSITE_DESTINATION_VISIT_RATE,
      sortable: true,
    },
    { key: "ixPageViewCount", label: IX_PAGE_VIEW_COUNT, sortable: true },
    {
      key: "costPerIxPageViewCount",
      label: COST_PER_IX_PAGE_VIEW_COUNT,
      sortable: true,
    },
    {
      key: "ixPageViewCountRate",
      label: IX_PAGE_VIEW_COUNT_RATE,
      sortable: true,
    },
    { key: "ixButtonClickCount", label: IX_BUTTON_CLICK_COUNT, sortable: true },
    {
      key: "costPerIxButtonClickCount",
      label: COST_PER_IX_BUTTON_CLICK_COUNT,
      sortable: true,
    },
    {
      key: "ixButtonClickCountRate",
      label: IX_BUTTON_CLICK_COUNT_RATE,
      sortable: true,
    },
    {
      key: "ixProductClickCount",
      label: IX_PRODUCT_CLICK_COUNT,
      sortable: true,
    },
    {
      key: "costPerIxProductClickCount",
      label: COST_PER_IX_PRODUCT_CLICK_COUNT,
      sortable: true,
    },
    {
      key: "ixProductClickCountRate",
      label: IX_PRODUCT_CLICK_COUNT_RATE,
      sortable: true,
    },
    {
      key: "offlineTotalCrmEvents",
      label: OFFLINE_TOTAL_CRM_EVENTS,
      sortable: true,
    },
    {
      key: "offlineCostPerCrmEvent",
      label: OFFLINE_COST_PER_CRM_EVENT,
      sortable: true,
    },
    {
      key: "offlineCrmEventRate",
      label: OFFLINE_CRM_EVENT_RATE,
      sortable: true,
    },
    {
      key: "offlineValuePerCrmEvent",
      label: OFFLINE_VALUE_PER_CRM_EVENT,
      sortable: true,
    },
    {
      key: "offlineCrmEventValue",
      label: OFFLINE_CRM_EVENT_VALUE,
      sortable: true,
    },
    {
      key: "offlineShoppingEvents",
      label: OFFLINE_SHOPPING_EVENTS,
      sortable: true,
    },
    {
      key: "costPerOfflineShoppingEvent",
      label: COST_PER_OFFLINE_SHOPPING_EVENT,
      sortable: true,
    },
    {
      key: "offlineShoppingEventRate",
      label: OFFLINE_SHOPPING_EVENT_RATE,
      sortable: true,
    },
    {
      key: "valuePerOfflineShoppingEvent",
      label: VALUE_PER_OFFLINE_SHOPPING_EVENT,
      sortable: true,
    },
    {
      key: "offlineShoppingEventsValue",
      label: OFFLINE_SHOPPING_EVENTS_VALUE,
      sortable: true,
    },
    {
      key: "offlineShoppingEventsRoas",
      label: OFFLINE_SHOPPING_EVENTS_ROAS,
      sortable: true,
    },
    {
      key: "offlineContactEvents",
      label: OFFLINE_CONTACT_EVENTS,
      sortable: true,
    },
    {
      key: "costPerOfflineContactEvent",
      label: COST_PER_OFFLINE_CONTACT_EVENT,
      sortable: true,
    },
    {
      key: "offlineContactEventRate",
      label: OFFLINE_CONTACT_EVENT_RATE,
      sortable: true,
    },
    {
      key: "valuePerOfflineContactEvent",
      label: VALUE_PER_OFFLINE_CONTACT_EVENT,
      sortable: true,
    },
    {
      key: "offlineContactEventsValue",
      label: OFFLINE_CONTACT_EVENTS_VALUE,
      sortable: true,
    },
    {
      key: "offlineSubscribeEvents",
      label: OFFLINE_SUBSCRIBE_EVENTS,
      sortable: true,
    },
    {
      key: "costPerOfflineSubscribeEvent",
      label: COST_PER_OFFLINE_SUBSCRIBE_EVENT,
      sortable: true,
    },
    {
      key: "offlineSubscribeEventRate",
      label: OFFLINE_SUBSCRIBE_EVENT_RATE,
      sortable: true,
    },
    {
      key: "valuePerOfflineSubscribeEvent",
      label: VALUE_PER_OFFLINE_SUBSCRIBE_EVENT,
      sortable: true,
    },
    {
      key: "offlineSubscribeEventsValue",
      label: OFFLINE_SUBSCRIBE_EVENTS_VALUE,
      sortable: true,
    },
    { key: "offlineFormEvents", label: OFFLINE_FORM_EVENTS, sortable: true },
    {
      key: "costPerOfflineFormEvent",
      label: COST_PER_OFFLINE_FORM_EVENT,
      sortable: true,
    },
    {
      key: "offlineFormEventRate",
      label: OFFLINE_FORM_EVENT_RATE,
      sortable: true,
    },
    {
      key: "valuePerOfflineFormEvent",
      label: VALUE_PER_OFFLINE_FORM_EVENT,
      sortable: true,
    },
    {
      key: "offlineFormEventsValue",
      label: OFFLINE_FORM_EVENTS_VALUE,
      sortable: true,
    },

    {
      key: "offlineAddPaymentInfoEvents",
      label: OFFLINE_ADD_PAYMENT_INFO_EVENTS,
      sortable: true,
    },
    {
      key: "costPerOfflineAddPaymentInfoEvent",
      label: COST_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT,
      sortable: true,
    },
    {
      key: "offlineAddPaymentInfoEventRate",
      label: OFFLINE_ADD_PAYMENT_INFO_EVENT_RATE,
      sortable: true,
    },
    {
      key: "valuePerOfflineAddPaymentInfoEvent",
      label: VALUE_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT,
      sortable: true,
    },
    {
      key: "offlineAddPaymentInfoEventsValue",
      label: OFFLINE_ADD_PAYMENT_INFO_EVENTS_VALUE,
      sortable: true,
    },

    {
      key: "offlineAddToCartEvents",
      label: OFFLINE_ADD_TO_CART_EVENTS,
      sortable: true,
    },
    {
      key: "costPerOfflineAddToCartEvent",
      label: COST_PER_OFFLINE_ADD_TO_CART_EVENT,
      sortable: true,
    },
    {
      key: "offlineAddToCartEventRate",
      label: OFFLINE_ADD_TO_CART_EVENT_RATE,
      sortable: true,
    },
    {
      key: "valuePerOfflineAddToCartEvent",
      label: VALUE_PER_OFFLINE_ADD_TO_CART_EVENT,
      sortable: true,
    },
    {
      key: "offlineAddToCartEventsValue",
      label: OFFLINE_ADD_TO_CART_EVENTS_VALUE,
      sortable: true,
    },

    {
      key: "offlineAddToWishlistEvents",
      label: OFFLINE_ADD_TO_WISHLIST_EVENTS,
      sortable: true,
    },
    {
      key: "costPerOfflineAddToWishlistEvent",
      label: COST_PER_OFFLINE_ADD_TO_WISHLIST_EVENT,
      sortable: true,
    },
    {
      key: "offlineAddToWishlistEventRate",
      label: OFFLINE_ADD_TO_WISHLIST_EVENT_RATE,
      sortable: true,
    },
    {
      key: "valuePerOfflineAddToWishlistEvent",
      label: VALUE_PER_OFFLINE_ADD_TO_WISHLIST_EVENT,
      sortable: true,
    },
    {
      key: "offlineAddToWishlistEventsValue",
      label: OFFLINE_ADD_TO_WISHLIST_EVENTS_VALUE,
      sortable: true,
    },

    {
      key: "offlineClickButtonEvents",
      label: OFFLINE_CLICK_BUTTON_EVENTS,
      sortable: true,
    },
    {
      key: "costPerOfflineClickButtonEvent",
      label: COST_PER_OFFLINE_CLICK_BUTTON_EVENT,
      sortable: true,
    },
    {
      key: "offlineClickButtonEventRate",
      label: OFFLINE_CLICK_BUTTON_EVENT_RATE,
      sortable: true,
    },
    {
      key: "valuePerOfflineClickButtonEvent",
      label: VALUE_PER_OFFLINE_CLICK_BUTTON_EVENT,
      sortable: true,
    },
    {
      key: "offlineClickButtonEventsValue",
      label: OFFLINE_CLICK_BUTTON_EVENTS_VALUE,
      sortable: true,
    },

    {
      key: "offlineCompleteRegistrationEvents",
      label: OFFLINE_COMPLETE_REGISTRATION_EVENTS,
      sortable: true,
    },
    {
      key: "costPerOfflineCompleteRegistrationEvent",
      label: COST_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT,
      sortable: true,
    },
    {
      key: "offlineCompleteRegistrationEventRate",
      label: OFFLINE_COMPLETE_REGISTRATION_EVENT_RATE,
      sortable: true,
    },
    {
      key: "valuePerOfflineCompleteRegistrationEvent",
      label: VALUE_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT,
      sortable: true,
    },
    {
      key: "offlineCompleteRegistrationEventsValue",
      label: OFFLINE_COMPLETE_REGISTRATION_EVENTS_VALUE,
      sortable: true,
    },

    {
      key: "offlineDownloadEvents",
      label: OFFLINE_DOWNLOAD_EVENTS,
      sortable: true,
    },
    {
      key: "costPerOfflineDownloadEvent",
      label: COST_PER_OFFLINE_DOWNLOAD_EVENT,
      sortable: true,
    },
    {
      key: "offlineDownloadEventRate",
      label: OFFLINE_DOWNLOAD_EVENT_RATE,
      sortable: true,
    },
    {
      key: "valuePerOfflineDownloadEvent",
      label: VALUE_PER_OFFLINE_DOWNLOAD_EVENT,
      sortable: true,
    },
    {
      key: "offlineDownloadEventsValue",
      label: OFFLINE_DOWNLOAD_EVENTS_VALUE,
      sortable: true,
    },

    {
      key: "offlineInitiateCheckoutEvents",
      label: OFFLINE_INITIATE_CHECKOUT_EVENTS,
      sortable: true,
    },
    {
      key: "costPerOfflineInitiateCheckoutEvent",
      label: COST_PER_OFFLINE_INITIATE_CHECKOUT_EVENT,
      sortable: true,
    },
    {
      key: "offlineInitiateCheckoutEventRate",
      label: OFFLINE_INITIATE_CHECKOUT_EVENT_RATE,
      sortable: true,
    },
    {
      key: "valuePerOfflineInitiateCheckoutEvent",
      label: VALUE_PER_OFFLINE_INITIATE_CHECKOUT_EVENT,
      sortable: true,
    },
    {
      key: "offlineInitiateCheckoutEventsValue",
      label: OFFLINE_INITIATE_CHECKOUT_EVENTS_VALUE,
      sortable: true,
    },

    {
      key: "offlinePlaceOrderEvents",
      label: OFFLINE_PLACE_ORDER_EVENTS,
      sortable: true,
    },
    {
      key: "costPerOfflinePlaceOrderEvent",
      label: COST_PER_OFFLINE_PLACE_ORDER_EVENT,
      sortable: true,
    },
    {
      key: "offlinePlaceOrderEventRate",
      label: OFFLINE_PLACE_ORDER_EVENT_RATE,
      sortable: true,
    },
    {
      key: "valuePerOfflinePlaceOrderEvent",
      label: VALUE_PER_OFFLINE_PLACE_ORDER_EVENT,
      sortable: true,
    },
    {
      key: "offlinePlaceOrderEventsValue",
      label: OFFLINE_PLACE_ORDER_EVENTS_VALUE,
      sortable: true,
    },

    {
      key: "offlineSearchEvents",
      label: OFFLINE_SEARCH_EVENTS,
      sortable: true,
    },
    {
      key: "costPerOfflineSearchEvent",
      label: COST_PER_OFFLINE_SEARCH_EVENT,
      sortable: true,
    },
    {
      key: "offlineSearchEventRate",
      label: OFFLINE_SEARCH_EVENT_RATE,
      sortable: true,
    },
    {
      key: "valuePerOfflineSearchEvent",
      label: VALUE_PER_OFFLINE_SEARCH_EVENT,
      sortable: true,
    },
    {
      key: "offlineSearchEventsValue",
      label: OFFLINE_SEARCH_EVENTS_VALUE,
      sortable: true,
    },

    {
      key: "offlineViewContentEvents",
      label: OFFLINE_VIEW_CONTENT_EVENTS,
      sortable: true,
    },
    {
      key: "costPerOfflineViewContentEvent",
      label: COST_PER_OFFLINE_VIEW_CONTENT_EVENT,
      sortable: true,
    },
    {
      key: "offlineViewContentEventRate",
      label: OFFLINE_VIEW_CONTENT_EVENT_RATE,
      sortable: true,
    },
    {
      key: "valuePerOfflineViewContentEvent",
      label: VALUE_PER_OFFLINE_VIEW_CONTENT_EVENT,
      sortable: true,
    },
    {
      key: "offlineViewContentEventsValue",
      label: OFFLINE_VIEW_CONTENT_EVENTS_VALUE,
      sortable: true,
    },

    {
      key: "offlinePreferredLeads",
      label: OFFLINE_PREFERRED_LEADS,
      sortable: true,
    },
    {
      key: "offlineCostPerPreferredLead",
      label: OFFLINE_COST_PER_PREFERRED_LEAD,
      sortable: true,
    },
    {
      key: "offlinePreferredLeadRate",
      label: OFFLINE_PREFERRED_LEAD_RATE,
      sortable: true,
    },

    {
      key: "offlineTotalFindLocation",
      label: OFFLINE_TOTAL_FIND_LOCATION,
      sortable: true,
    },
    {
      key: "offlineCostPerFindLocation",
      label: OFFLINE_COST_PER_FIND_LOCATION,
      sortable: true,
    },
    {
      key: "offlineFindLocationRate",
      label: OFFLINE_FIND_LOCATION_RATE,
      sortable: true,
    },
    {
      key: "offlineValuePerFindLocation",
      label: OFFLINE_VALUE_PER_FIND_LOCATION,
      sortable: true,
    },
    {
      key: "offlineTotalFindLocationValue",
      label: OFFLINE_TOTAL_FIND_LOCATION_VALUE,
      sortable: true,
    },

    {
      key: "offlineTotalSchedule",
      label: OFFLINE_TOTAL_SCHEDULE,
      sortable: true,
    },
    {
      key: "offlineCostPerSchedule",
      label: OFFLINE_COST_PER_SCHEDULE,
      sortable: true,
    },
    {
      key: "offlineScheduleRate",
      label: OFFLINE_SCHEDULE_RATE,
      sortable: true,
    },
    {
      key: "offlineValuePerSchedule",
      label: OFFLINE_VALUE_PER_SCHEDULE,
      sortable: true,
    },
    {
      key: "offlineTotalScheduleValue",
      label: OFFLINE_TOTAL_SCHEDULE_VALUE,
      sortable: true,
    },

    {
      key: "offlineTotalCustomizeProduct",
      label: OFFLINE_TOTAL_CUSTOMIZE_PRODUCT,
      sortable: true,
    },
    {
      key: "offlineCostPerCustomizeProduct",
      label: OFFLINE_COST_PER_CUSTOMIZE_PRODUCT,
      sortable: true,
    },
    {
      key: "offlineCustomizeProductRate",
      label: OFFLINE_CUSTOMIZE_PRODUCT_RATE,
      sortable: true,
    },
    {
      key: "offlineValuePerCustomizeProduct",
      label: OFFLINE_VALUE_PER_CUSTOMIZE_PRODUCT,
      sortable: true,
    },
    {
      key: "offlineTotalCustomizeProductValue",
      label: OFFLINE_TOTAL_CUSTOMIZE_PRODUCT_VALUE,
      sortable: true,
    },

    {
      key: "offlineTotalCustomEvents",
      label: OFFLINE_TOTAL_CUSTOM_EVENTS,
      sortable: true,
    },
    {
      key: "offlineCostPerCustomEvent",
      label: OFFLINE_COST_PER_CUSTOM_EVENT,
      sortable: true,
    },
    {
      key: "offlineCustomEventRate",
      label: OFFLINE_CUSTOM_EVENT_RATE,
      sortable: true,
    },
    {
      key: "offlineValuePerCustomEvent",
      label: OFFLINE_VALUE_PER_CUSTOM_EVENT,
      sortable: true,
    },
    {
      key: "offlineTotalCustomEventValue",
      label: OFFLINE_TOTAL_CUSTOM_EVENT_VALUE,
      sortable: true,
    },

    {
      key: "messagingTotalConversationTiktokDirectMessage",
      label: MESSAGING_TOTAL_CONVERSATION_TIKTOK_DIRECT_MESSAGE,
      sortable: true,
    },
    {
      key: "messagingCostPerConversationTiktokDirectMessage",
      label: MESSAGING_COST_PER_CONVERSATION_TIKTOK_DIRECT_MESSAGE,
      sortable: true,
    },
    {
      key: "messagingConversationRateTiktokDirectMessage",
      label: MESSAGING_CONVERSATION_RATE_TIKTOK_DIRECT_MESSAGE,
      sortable: true,
    },

    {
      key: "messagingTotalConversationInstantMessagingApp",
      label: MESSAGING_TOTAL_CONVERSATION_INSTANT_MESSAGING_APP,
      sortable: true,
    },
    {
      key: "messagingCostPerConversationInstantMessagingApp",
      label: MESSAGING_COST_PER_CONVERSATION_INSTANT_MESSAGING_APP,
      sortable: true,
    },
    {
      key: "messagingConversationRateInstantMessagingApp",
      label: MESSAGING_CONVERSATION_RATE_INSTANT_MESSAGING_APP,
      sortable: true,
    },

    { key: "onsiteShoppingRoas", label: ONSITE_SHOPPING_ROAS, sortable: true },

    { key: "onsiteShopping", label: ONSITE_SHOPPING, sortable: true },
    {
      key: "costPerOnsiteShopping",
      label: COST_PER_ONSITE_SHOPPING,
      sortable: true,
    },
    { key: "onsiteShoppingRate", label: ONSITE_SHOPPING_RATE, sortable: true },
    {
      key: "valuePerOnsiteShopping",
      label: VALUE_PER_ONSITE_SHOPPING,
      sortable: true,
    },
    {
      key: "totalOnsiteShoppingValue",
      label: TOTAL_ONSITE_SHOPPING_VALUE,
      sortable: true,
    },
    {
      key: "shopTotalPurchaseByOrderSubmission",
      label: SHOP_TOTAL_PURCHASE_BY_ORDER_SUBMISSION,
      sortable: true,
    },
    {
      key: "shopGrossRevenueByOrderSubmission",
      label: SHOP_GROSS_REVENUE_BY_ORDER_SUBMISSION,
      sortable: true,
    },
    {
      key: "shopTotalItemsPurchased",
      label: SHOP_TOTAL_ITEMS_PURCHASED,
      sortable: true,
    },
    {
      key: "onsiteInitiateCheckoutCount",
      label: ONSITE_INITIATE_CHECKOUT_COUNT,
      sortable: true,
    },
    {
      key: "costPerOnsiteInitiateCheckoutCount",
      label: COST_PER_ONSITE_INITIATE_CHECKOUT_COUNT,
      sortable: true,
    },
    {
      key: "onsiteInitiateCheckoutCountRate",
      label: ONSITE_INITIATE_CHECKOUT_COUNT_RATE,
      sortable: true,
    },
    {
      key: "valuePerOnsiteInitiateCheckoutCount",
      label: VALUE_PER_ONSITE_INITIATE_CHECKOUT_COUNT,
      sortable: true,
    },
    {
      key: "totalOnsiteInitiateCheckoutCountValue",
      label: TOTAL_ONSITE_INITIATE_CHECKOUT_COUNT_VALUE,
      sortable: true,
    },
    { key: "onsiteOnWebDetail", label: ONSITE_ON_WEB_DETAIL, sortable: true },
    {
      key: "costPerOnsiteOnWebDetail",
      label: COST_PER_ONSITE_ON_WEB_DETAIL,
      sortable: true,
    },
    {
      key: "onsiteOnWebDetailRate",
      label: ONSITE_ON_WEB_DETAIL_RATE,
      sortable: true,
    },
    {
      key: "valuePerOnsiteOnWebDetail",
      label: VALUE_PER_ONSITE_ON_WEB_DETAIL,
      sortable: true,
    },
    {
      key: "totalOnsiteOnWebDetailValue",
      label: TOTAL_ONSITE_ON_WEB_DETAIL_VALUE,
      sortable: true,
    },
    { key: "onsiteOnWebCart", label: ONSITE_ON_WEB_CART, sortable: true },
    {
      key: "costPerOnsiteOnWebCart",
      label: COST_PER_ONSITE_ON_WEB_CART,
      sortable: true,
    },
    {
      key: "onsiteOnWebCartRate",
      label: ONSITE_ON_WEB_CART_RATE,
      sortable: true,
    },
    {
      key: "valuePerOnsiteOnWebCart",
      label: VALUE_PER_ONSITE_ON_WEB_CART,
      sortable: true,
    },
    {
      key: "totalOnsiteOnWebCartValue",
      label: TOTAL_ONSITE_ON_WEB_CART_VALUE,
      sortable: true,
    },
    { key: "vtaConversion", label: VTA_CONVERSION, sortable: true },
    {
      key: "costPerVtaConversion",
      label: COST_PER_VTA_CONVERSION,
      sortable: true,
    },
    { key: "ctaConversion", label: CTA_CONVERSION, sortable: true },
    {
      key: "costPerCtaConversion",
      label: COST_PER_CTA_CONVERSION,
      sortable: true,
    },
    {
      key: "engagedViewThroughConversions",
      label: ENGAGED_VIEW_THROUGH_CONVERSIONS,
      sortable: true,
    },
    {
      key: "costPerEngagedViewThroughConversion",
      label: COST_PER_ENGAGED_VIEW_THROUGH_CONVERSION,
      sortable: true,
    },
    { key: "vtaAppInstall", label: VTA_APP_INSTALL, sortable: true },
    {
      key: "costPerVtaAppInstall",
      label: COST_PER_VTA_APP_INSTALL,
      sortable: true,
    },
    { key: "ctaAppInstall", label: CTA_APP_INSTALL, sortable: true },
    {
      key: "costPerCtaAppInstall",
      label: COST_PER_CTA_APP_INSTALL,
      sortable: true,
    },
    { key: "evtaAppInstall", label: EVTA_APP_INSTALL, sortable: true },
    {
      key: "costPerEvtaAppInstall",
      label: COST_PER_EVTA_APP_INSTALL,
      sortable: true,
    },
    { key: "vtaRegistration", label: VTA_REGISTRATION, sortable: true },
    {
      key: "costPerVtaRegistration",
      label: COST_PER_VTA_REGISTRATION,
      sortable: true,
    },
    { key: "ctaRegistration", label: CTA_REGISTRATION, sortable: true },
    {
      key: "costPerCtaRegistration",
      label: COST_PER_CTA_REGISTRATION,
      sortable: true,
    },
    { key: "evtaRegistration", label: EVTA_REGISTRATION, sortable: true },
    {
      key: "costPerEvtaRegistration",
      label: COST_PER_EVTA_REGISTRATION,
      sortable: true,
    },
    { key: "vtaPurchase", label: VTA_PURCHASE, sortable: true },
    { key: "costPerVtaPurchase", label: COST_PER_VTA_PURCHASE, sortable: true },
    { key: "ctaPurchase", label: CTA_PURCHASE, sortable: true },
    { key: "costPerCtaPurchase", label: COST_PER_CTA_PURCHASE, sortable: true },
    { key: "evtaPurchase", label: EVTA_PURCHASE, sortable: true },
    {
      key: "costPerEvtaPurchase",
      label: COST_PER_EVTA_PURCHASE,
      sortable: true,
    },
    { key: "vtaCompletePayment", label: VTA_COMPLETE_PAYMENT, sortable: true },
    {
      key: "costPerVtaPaymentsCompleted",
      label: COST_PER_VTA_PAYMENTS_COMPLETED,
      sortable: true,
    },
    {
      key: "evtaPaymentsCompleted",
      label: EVTA_PAYMENTS_COMPLETED,
      sortable: true,
    },
    {
      key: "costPerEvtaPaymentsCompleted",
      label: COST_PER_EVTA_PAYMENTS_COMPLETED,
      sortable: true,
    },
    {
      key: "vtaCompletePaymentValue",
      label: VTA_COMPLETE_PAYMENT_VALUE,
      sortable: true,
    },
    {
      key: "vtaCompletePaymentRoas",
      label: VTA_COMPLETE_PAYMENT_ROAS,
      sortable: true,
    },

    { key: "skanResult", label: SKAN_RESULT, sortable: true },
    { key: "skanCostPerResult", label: SKAN_COST_PER_RESULT, sortable: true },
    { key: "skanResultRate", label: SKAN_RESULT_RATE, sortable: true },
    { key: "skanConversion", label: SKAN_CONVERSION, sortable: true },
    {
      key: "skanCostPerConversion",
      label: SKAN_COST_PER_CONVERSION,
      sortable: true,
    },
    { key: "skanConversionRate", label: SKAN_CONVERSION_RATE, sortable: true },
    {
      key: "skanConversionRateV2",
      label: SKAN_CONVERSION_RATE_V2,
      sortable: true,
    },
    {
      key: "skanClickTimeConversion",
      label: SKAN_CLICK_TIME_CONVERSION,
      sortable: true,
    },
    {
      key: "skanClickTimeCostPerConversion",
      label: SKAN_CLICK_TIME_COST_PER_CONVERSION,
      sortable: true,
    },
    {
      key: "skanClickTimeConversionRate",
      label: SKAN_CLICK_TIME_CONVERSION_RATE,
      sortable: true,
    },
    {
      key: "skanClickTimeConversionRateV2",
      label: SKAN_CLICK_TIME_CONVERSION_RATE_V2,
      sortable: true,
    },
    { key: "skanAppInstall", label: SKAN_APP_INSTALL, sortable: true },
    {
      key: "skanCostPerAppInstall",
      label: SKAN_COST_PER_APP_INSTALL,
      sortable: true,
    },
    {
      key: "skanAppInstallWithheld",
      label: SKAN_APP_INSTALL_WITHHELD,
      sortable: true,
    },
    { key: "skanRegistration", label: SKAN_REGISTRATION, sortable: true },
    {
      key: "skanCostPerRegistration",
      label: SKAN_COST_PER_REGISTRATION,
      sortable: true,
    },
    {
      key: "skanRegistrationRate",
      label: SKAN_REGISTRATION_RATE,
      sortable: true,
    },
    {
      key: "skanTotalRegistration",
      label: SKAN_TOTAL_REGISTRATION,
      sortable: true,
    },
    {
      key: "skanCostPerTotalRegistration",
      label: SKAN_COST_PER_TOTAL_REGISTRATION,
      sortable: true,
    },
    { key: "skanPurchase", label: SKAN_PURCHASE, sortable: true },
    {
      key: "skanCostPerPurchase",
      label: SKAN_COST_PER_PURCHASE,
      sortable: true,
    },
    { key: "skanPurchaseRate", label: SKAN_PURCHASE_RATE, sortable: true },
    { key: "skanTotalPurchase", label: SKAN_TOTAL_PURCHASE, sortable: true },
    {
      key: "skanCostPerTotalPurchase",
      label: SKAN_COST_PER_TOTAL_PURCHASE,
      sortable: true,
    },
    {
      key: "skanTotalPurchaseValue",
      label: SKAN_TOTAL_PURCHASE_VALUE,
      sortable: true,
    },
    {
      key: "skanTotalRepetitiveActivePayRoas",
      label: SKAN_TOTAL_REPETITIVE_ACTIVE_PAY_ROAS,
      sortable: true,
    },
    { key: "skanAddToCart", label: SKAN_ADD_TO_CART, sortable: true },
    {
      key: "skanCostPerAddToCart",
      label: SKAN_COST_PER_ADD_TO_CART,
      sortable: true,
    },
    { key: "skanAddToCartRate", label: SKAN_ADD_TO_CART_RATE, sortable: true },
    {
      key: "skanTotalAddToCart",
      label: SKAN_TOTAL_ADD_TO_CART,
      sortable: true,
    },
    {
      key: "skanCostPerTotalAddToCart",
      label: SKAN_COST_PER_TOTAL_ADD_TO_CART,
      sortable: true,
    },
    {
      key: "skanTotalAddToCartValue",
      label: SKAN_TOTAL_ADD_TO_CART_VALUE,
      sortable: true,
    },
    { key: "skanCheckout", label: SKAN_CHECKOUT, sortable: true },
    {
      key: "skanCostPerCheckout",
      label: SKAN_COST_PER_CHECKOUT,
      sortable: true,
    },
    { key: "skanCheckoutRate", label: SKAN_CHECKOUT_RATE, sortable: true },
    { key: "skanTotalCheckout", label: SKAN_TOTAL_CHECKOUT, sortable: true },
    {
      key: "skanCostPerTotalCheckout",
      label: SKAN_COST_PER_TOTAL_CHECKOUT,
      sortable: true,
    },
    {
      key: "skanTotalCheckoutValue",
      label: SKAN_TOTAL_CHECKOUT_VALUE,
      sortable: true,
    },
    { key: "skanViewContent", label: SKAN_VIEW_CONTENT, sortable: true },
    {
      key: "skanCostPerViewContent",
      label: SKAN_COST_PER_VIEW_CONTENT,
      sortable: true,
    },
    {
      key: "skanViewContentRate",
      label: SKAN_VIEW_CONTENT_RATE,
      sortable: true,
    },
    {
      key: "skanTotalViewContent",
      label: SKAN_TOTAL_VIEW_CONTENT,
      sortable: true,
    },
    {
      key: "skanCostPerTotalViewContent",
      label: SKAN_COST_PER_TOTAL_VIEW_CONTENT,
      sortable: true,
    },
    {
      key: "skanTotalViewContentValue",
      label: SKAN_TOTAL_VIEW_CONTENT_VALUE,
      sortable: true,
    },
    { key: "skanAddPaymentInfo", label: SKAN_ADD_PAYMENT_INFO, sortable: true },
    {
      key: "skanCostPerAddPaymentInfo",
      label: SKAN_COST_PER_ADD_PAYMENT_INFO,
      sortable: true,
    },
    {
      key: "skanAddPaymentInfoRate",
      label: SKAN_ADD_PAYMENT_INFO_RATE,
      sortable: true,
    },
    {
      key: "skanTotalAddPaymentInfo",
      label: SKAN_TOTAL_ADD_PAYMENT_INFO,
      sortable: true,
    },
    {
      key: "skanCostTotalAddPaymentInfo",
      label: SKAN_COST_TOTAL_ADD_PAYMENT_INFO,
      sortable: true,
    },
    { key: "skanAddToWishlist", label: SKAN_ADD_TO_WISHLIST, sortable: true },
    {
      key: "skanCostPerAddToWishlist",
      label: SKAN_COST_PER_ADD_TO_WISHLIST,
      sortable: true,
    },
    {
      key: "skanAddToWishlistRate",
      label: SKAN_ADD_TO_WISHLIST_RATE,
      sortable: true,
    },
    {
      key: "skanTotalAddToWishlist",
      label: SKAN_TOTAL_ADD_TO_WISHLIST,
      sortable: true,
    },
    {
      key: "skanCostPerTotalAddToWishlist",
      label: SKAN_COST_PER_TOTAL_ADD_TO_WISHLIST,
      sortable: true,
    },
    {
      key: "skanTotalAddToWishlistValue",
      label: SKAN_TOTAL_ADD_TO_WISHLIST_VALUE,
      sortable: true,
    },
    { key: "skanLaunchApp", label: SKAN_LAUNCH_APP, sortable: true },
    {
      key: "skanCostPerLaunchApp",
      label: SKAN_COST_PER_LAUNCH_APP,
      sortable: true,
    },
    { key: "skanLaunchAppRate", label: SKAN_LAUNCH_APP_RATE, sortable: true },
    { key: "skanTotalLaunchApp", label: SKAN_TOTAL_LAUNCH_APP, sortable: true },
    {
      key: "skanCostPerTotalLaunchApp",
      label: SKAN_COST_PER_TOTAL_LAUNCH_APP,
      sortable: true,
    },
    {
      key: "skanCompleteTutorial",
      label: SKAN_COMPLETE_TUTORIAL,
      sortable: true,
    },
    {
      key: "skanCostPerCompleteTutorial",
      label: SKAN_COST_PER_COMPLETE_TUTORIAL,
      sortable: true,
    },
    {
      key: "skanCompleteTutorialRate",
      label: SKAN_COMPLETE_TUTORIAL_RATE,
      sortable: true,
    },
    {
      key: "skanTotalCompleteTutorial",
      label: SKAN_TOTAL_COMPLETE_TUTORIAL,
      sortable: true,
    },
    {
      key: "skanCostPerTotalCompleteTutorial",
      label: SKAN_COST_PER_TOTAL_COMPLETE_TUTORIAL,
      sortable: true,
    },
    {
      key: "skanTotalCompleteTutorialValue",
      label: SKAN_TOTAL_COMPLETE_TUTORIAL_VALUE,
      sortable: true,
    },
    { key: "skanCreateGroup", label: SKAN_CREATE_GROUP, sortable: true },
    {
      key: "skanCostPerCreateGroup",
      label: SKAN_COST_PER_CREATE_GROUP,
      sortable: true,
    },
    {
      key: "skanCreateGroupRate",
      label: SKAN_CREATE_GROUP_RATE,
      sortable: true,
    },
    {
      key: "skanTotalCreateGroup",
      label: SKAN_TOTAL_CREATE_GROUP,
      sortable: true,
    },
    {
      key: "skanCostPerTotalCreateGroup",
      label: SKAN_COST_PER_TOTAL_CREATE_GROUP,
      sortable: true,
    },
    {
      key: "skanTotalCreateGroupValue",
      label: SKAN_TOTAL_CREATE_GROUP_VALUE,
      sortable: true,
    },
    { key: "skanJoinGroup", label: SKAN_JOIN_GROUP, sortable: true },
    {
      key: "skanCostPerJoinGroup",
      label: SKAN_COST_PER_JOIN_GROUP,
      sortable: true,
    },
    { key: "skanJoinGroupRate", label: SKAN_JOIN_GROUP_RATE, sortable: true },
    { key: "skanTotalJoinGroup", label: SKAN_TOTAL_JOIN_GROUP, sortable: true },
    {
      key: "skanCostPerTotalJoinGroup",
      label: SKAN_COST_PER_TOTAL_JOIN_GROUP,
      sortable: true,
    },
    {
      key: "skanTotalJoinGroupValue",
      label: SKAN_TOTAL_JOIN_GROUP_VALUE,
      sortable: true,
    },
    { key: "skanCreateGamerole", label: SKAN_CREATE_GAMEROLE, sortable: true },
    {
      key: "skanCostPerCreateGamerole",
      label: SKAN_COST_PER_CREATE_GAMEROLE,
      sortable: true,
    },
    {
      key: "skanCreateGameroleRate",
      label: SKAN_CREATE_GAMEROLE_RATE,
      sortable: true,
    },
    {
      key: "skanTotalCreateGamerole",
      label: SKAN_TOTAL_CREATE_GAMEROLE,
      sortable: true,
    },
    {
      key: "skanCostPerTotalCreateGamerole",
      label: SKAN_COST_PER_TOTAL_CREATE_GAMEROLE,
      sortable: true,
    },
    {
      key: "skanTotalCreateGameroleValue",
      label: SKAN_TOTAL_CREATE_GAMEROLE_VALUE,
      sortable: true,
    },
    { key: "skanSpendCredits", label: SKAN_SPEND_CREDITS, sortable: true },
    {
      key: "skanCostPerSpendCredits",
      label: SKAN_COST_PER_SPEND_CREDITS,
      sortable: true,
    },
    {
      key: "skanSpendCreditsRate",
      label: SKAN_SPEND_CREDITS_RATE,
      sortable: true,
    },
    {
      key: "skanTotalSpendCredits",
      label: SKAN_TOTAL_SPEND_CREDITS,
      sortable: true,
    },
    {
      key: "skanCostPerTotalSpendCredits",
      label: SKAN_COST_PER_TOTAL_SPEND_CREDITS,
      sortable: true,
    },
    {
      key: "skanTotalSpendCreditsValue",
      label: SKAN_TOTAL_SPEND_CREDITS_VALUE,
      sortable: true,
    },
    { key: "skanAchieveLevel", label: SKAN_ACHIEVE_LEVEL, sortable: true },
    {
      key: "skanCostPerAchieveLevel",
      label: SKAN_COST_PER_ACHIEVE_LEVEL,
      sortable: true,
    },
    {
      key: "skanAchieveLevelRate",
      label: SKAN_ACHIEVE_LEVEL_RATE,
      sortable: true,
    },
    {
      key: "skanTotalAchieveLevel",
      label: SKAN_TOTAL_ACHIEVE_LEVEL,
      sortable: true,
    },
    {
      key: "skanCostPerTotalAchieveLevel",
      label: SKAN_COST_PER_TOTAL_ACHIEVE_LEVEL,
      sortable: true,
    },
    {
      key: "skanTotalAchieveLevelValue",
      label: SKAN_TOTAL_ACHIEVE_LEVEL_VALUE,
      sortable: true,
    },
    {
      key: "skanUnlockAchievement",
      label: SKAN_UNLOCK_ACHIEVEMENT,
      sortable: true,
    },
    {
      key: "skanCostPerUnlockAchievement",
      label: SKAN_COST_PER_UNLOCK_ACHIEVEMENT,
      sortable: true,
    },
    {
      key: "skanUnlockAchievementRate",
      label: SKAN_UNLOCK_ACHIEVEMENT_RATE,
      sortable: true,
    },
    {
      key: "skanTotalUnlockAchievement",
      label: SKAN_TOTAL_UNLOCK_ACHIEVEMENT,
      sortable: true,
    },
    {
      key: "skanCostPerTotalUnlockAchievement",
      label: SKAN_COST_PER_TOTAL_UNLOCK_ACHIEVEMENT,
      sortable: true,
    },
    {
      key: "skanTotalUnlockAchievementValue",
      label: SKAN_TOTAL_UNLOCK_ACHIEVEMENT_VALUE,
      sortable: true,
    },
    { key: "skanSalesLead", label: SKAN_SALES_LEAD, sortable: true },
    {
      key: "skanCostPerSalesLead",
      label: SKAN_COST_PER_SALES_LEAD,
      sortable: true,
    },
    { key: "skanSalesLeadRate", label: SKAN_SALES_LEAD_RATE, sortable: true },
    { key: "skanTotalSalesLead", label: SKAN_TOTAL_SALES_LEAD, sortable: true },
    {
      key: "skanCostPerTotalSalesLead",
      label: SKAN_COST_PER_TOTAL_SALES_LEAD,
      sortable: true,
    },
    {
      key: "skanTotalSalesLeadValue",
      label: SKAN_TOTAL_SALES_LEAD_VALUE,
      sortable: true,
    },
    { key: "skanInAppAdClick", label: SKAN_IN_APP_AD_CLICK, sortable: true },
    {
      key: "skanCostPerInAppAdClick",
      label: SKAN_COST_PER_IN_APP_AD_CLICK,
      sortable: true,
    },
    {
      key: "skanInAppAdClickRate",
      label: SKAN_IN_APP_AD_CLICK_RATE,
      sortable: true,
    },
    {
      key: "skanTotalInAppAdClick",
      label: SKAN_TOTAL_IN_APP_AD_CLICK,
      sortable: true,
    },
    {
      key: "skanCostPerTotalInAppAdClick",
      label: SKAN_COST_PER_TOTAL_IN_APP_AD_CLICK,
      sortable: true,
    },
    {
      key: "skanTotalInAppAdClickValue",
      label: SKAN_TOTAL_IN_APP_AD_CLICK_VALUE,
      sortable: true,
    },
    { key: "skanInAppAdImpr", label: SKAN_IN_APP_AD_IMPR, sortable: true },
    {
      key: "skanCostPerInAppAdImpr",
      label: SKAN_COST_PER_IN_APP_AD_IMPR,
      sortable: true,
    },
    {
      key: "skanInAppAdImprRate",
      label: SKAN_IN_APP_AD_IMPR_RATE,
      sortable: true,
    },
    {
      key: "skanTotalInAppAdImpr",
      label: SKAN_TOTAL_IN_APP_AD_IMPR,
      sortable: true,
    },
    {
      key: "skanCostPerTotalInAppAdImpr",
      label: SKAN_COST_PER_TOTAL_IN_APP_AD_IMPR,
      sortable: true,
    },
    {
      key: "skanTotalInAppAdImprValue",
      label: SKAN_TOTAL_IN_APP_AD_IMPR_VALUE,
      sortable: true,
    },
    { key: "skanLoanApply", label: SKAN_LOAN_APPLY, sortable: true },
    {
      key: "skanCostPerLoanApply",
      label: SKAN_COST_PER_LOAN_APPLY,
      sortable: true,
    },
    { key: "skanLoanApplyRate", label: SKAN_LOAN_APPLY_RATE, sortable: true },
    { key: "skanTotalLoanApply", label: SKAN_TOTAL_LOAN_APPLY, sortable: true },
    {
      key: "skanCostPerTotalLoanApply",
      label: SKAN_COST_PER_TOTAL_LOAN_APPLY,
      sortable: true,
    },
    { key: "skanLoanCredit", label: SKAN_LOAN_CREDIT, sortable: true },
    {
      key: "skanCostPerLoanCredit",
      label: SKAN_COST_PER_LOAN_CREDIT,
      sortable: true,
    },
    { key: "skanLoanCreditRate", label: SKAN_LOAN_CREDIT_RATE, sortable: true },
    {
      key: "skanTotalLoanCredit",
      label: SKAN_TOTAL_LOAN_CREDIT,
      sortable: true,
    },
    {
      key: "skanCostPerTotalLoanCredit",
      label: SKAN_COST_PER_TOTAL_LOAN_CREDIT,
      sortable: true,
    },
    {
      key: "skanLoanDisbursement",
      label: SKAN_LOAN_DISBURSEMENT,
      sortable: true,
    },
    {
      key: "skanCostPerLoanDisbursement",
      label: SKAN_COST_PER_LOAN_DISBURSEMENT,
      sortable: true,
    },
    {
      key: "skanLoanDisbursementRate",
      label: SKAN_LOAN_DISBURSEMENT_RATE,
      sortable: true,
    },
    {
      key: "skanTotalLoanDisbursement",
      label: SKAN_TOTAL_LOAN_DISBURSEMENT,
      sortable: true,
    },
    {
      key: "skanCostPerTotalLoanDisbursement",
      label: SKAN_COST_PER_TOTAL_LOAN_DISBURSEMENT,
      sortable: true,
    },
    { key: "skanLogin", label: SKAN_LOGIN, sortable: true },
    { key: "skanCostPerLogin", label: SKAN_COST_PER_LOGIN, sortable: true },
    { key: "skanLoginRate", label: SKAN_LOGIN_RATE, sortable: true },
    { key: "skanTotalLogin", label: SKAN_TOTAL_LOGIN, sortable: true },
    {
      key: "skanCostPerTotalLogin",
      label: SKAN_COST_PER_TOTAL_LOGIN,
      sortable: true,
    },
    { key: "skanRatings", label: SKAN_RATINGS, sortable: true },
    { key: "skanCostPerRatings", label: SKAN_COST_PER_RATINGS, sortable: true },
    { key: "skanRatingsRate", label: SKAN_RATINGS_RATE, sortable: true },
    { key: "skanTotalRatings", label: SKAN_TOTAL_RATINGS, sortable: true },
    {
      key: "skanCostPerTotalRatings",
      label: SKAN_COST_PER_TOTAL_RATINGS,
      sortable: true,
    },
    {
      key: "skanTotalRatingsValue",
      label: SKAN_TOTAL_RATINGS_VALUE,
      sortable: true,
    },
    { key: "skanSearch", label: SKAN_SEARCH, sortable: true },
    { key: "skanCostPerSearch", label: SKAN_COST_PER_SEARCH, sortable: true },
    { key: "skanSearchRate", label: SKAN_SEARCH_RATE, sortable: true },
    { key: "skanTotalSearch", label: SKAN_TOTAL_SEARCH, sortable: true },
    {
      key: "skanCostPerTotalSearch",
      label: SKAN_COST_PER_TOTAL_SEARCH,
      sortable: true,
    },
    { key: "skanStartTrial", label: SKAN_START_TRIAL, sortable: true },
    {
      key: "skanCostPerStartTrial",
      label: SKAN_COST_PER_START_TRIAL,
      sortable: true,
    },
    { key: "skanStartTrialRate", label: SKAN_START_TRIAL_RATE, sortable: true },
    {
      key: "skanTotalStartTrial",
      label: SKAN_TOTAL_START_TRIAL,
      sortable: true,
    },
    {
      key: "skanCostPerTotalStartTrial",
      label: SKAN_COST_PER_TOTAL_START_TRIAL,
      sortable: true,
    },
    { key: "skanSubscribe", label: SKAN_SUBSCRIBE, sortable: true },
    {
      key: "skanCostPerSubscribe",
      label: SKAN_COST_PER_SUBSCRIBE,
      sortable: true,
    },
    { key: "skanSubscribeRate", label: SKAN_SUBSCRIBE_RATE, sortable: true },
    { key: "skanTotalSubscribe", label: SKAN_TOTAL_SUBSCRIBE, sortable: true },
    {
      key: "skanCostPerTotalSubscribe",
      label: SKAN_COST_PER_TOTAL_SUBSCRIBE,
      sortable: true,
    },
    {
      key: "skanTotalSubscribeValue",
      label: SKAN_TOTAL_SUBSCRIBE_VALUE,
      sortable: true,
    },
    { key: "skanVtaConversion", label: SKAN_VTA_CONVERSION, sortable: true },
    {
      key: "skanCostPerVtaConversion",
      label: SKAN_COST_PER_VTA_CONVERSION,
      sortable: true,
    },
    { key: "skanVtaAppInstall", label: SKAN_VTA_APP_INSTALL, sortable: true },
    {
      key: "skanCostPerVtaAppInstall",
      label: SKAN_COST_PER_VTA_APP_INSTALL,
      sortable: true,
    },
    {
      key: "skanVtaRegistration",
      label: SKAN_VTA_REGISTRATION,
      sortable: true,
    },
    {
      key: "skanCostPerVtaRegistration",
      label: SKAN_COST_PER_VTA_REGISTRATION,
      sortable: true,
    },
    { key: "skanVtaPurchase", label: SKAN_VTA_PURCHASE, sortable: true },
    {
      key: "skanCostPerVtaPurchase",
      label: SKAN_COST_PER_VTA_PURCHASE,
      sortable: true,
    },
    { key: "skanCtaConversion", label: SKAN_CTA_CONVERSION, sortable: true },
    {
      key: "skanCostPerCtaConversion",
      label: SKAN_COST_PER_CTA_CONVERSION,
      sortable: true,
    },
    { key: "skanCtaAppInstall", label: SKAN_CTA_APP_INSTALL, sortable: true },
    {
      key: "skanCostPerCtaAppInstall",
      label: SKAN_COST_PER_CTA_APP_INSTALL,
      sortable: true,
    },
    {
      key: "skanCtaRegistration",
      label: SKAN_CTA_REGISTRATION,
      sortable: true,
    },
    {
      key: "skanCostPerCtaRegistration",
      label: SKAN_COST_PER_CTA_REGISTRATION,
      sortable: true,
    },
    { key: "skanCtaPurchase", label: SKAN_CTA_PURCHASE, sortable: true },
    {
      key: "skanCostPerCtaPurchase",
      label: SKAN_COST_PER_CTA_PURCHASE,
      sortable: true,
    },
  ],
  [LINKEDIN]: [...LINKEDIN_BASIC_METRICS, ...LINKEDIN_ADDITIONAL_METRICS],
};
